const CVE = [
    'CVE-2013-3900',
    'CVE-2023-23397',
    'CVE-2021-44228',
    'CVE-2023-28252',
    'CVE-2016-2183',
    'CVE-2022-1471',
    'CVE-2022-22965',
    'CVE-2022-30190',
    'CVE-2023-23529',
    'CVE-2023-2033',
    'CVE-2021-4034',
    'CVE-2022-1292',
    'CVE-2023-0286',
    'CVE-2022-2588',
    'CVE-2022-32893',
    'CVE-2022-37434',
    'CVE-2022-34169',
    'CVE-2020-1472',
    'CVE-2022-47966',
    'CVE-2023-21554',
    'CVE-2021-3560',
    'CVE-2021-44832',
    'CVE-2022-2068',
    'CVE-2022-1388',
    'CVE-2022-38023',
    'CVE-2014-6271',
    'CVE-2021-21974',
    'CVE-2022-43552',
    'CVE-2022-34713',
    'CVE-2022-2294',
    'CVE-2023-21674',
    'CVE-2021-4104',
    'CVE-2022-37969',
    'CVE-2021-34527',
    'CVE-2022-0847',
    'CVE-2022-26809',
    'CVE-2017-8529',
    'CVE-2018-3646',
    'CVE-2022-40674',
    'CVE-2023-21716',
    'CVE-2022-3075',
    'CVE-2022-27518',
    'CVE-2022-31676',
    'CVE-2017-11882',
    'CVE-2021-40438',
    'CVE-2017-0144',
    'CVE-2022-37454',
    'CVE-2023-24998',
    'CVE-2022-34718',
    'CVE-2022-27510',
    'CVE-2023-23415',
    'CVE-2023-0669',
    'CVE-2022-2856',
    'CVE-2022-37967',
    'CVE-2022-41080',
    'CVE-2019-17571',
    'CVE-2020-1938',
    'CVE-2022-42003',
    'CVE-2023-24932',
    'CVE-2022-31813',
    'CVE-2020-11022',
    'CVE-2018-25032',
    'CVE-2022-41128',
    'CVE-2023-22809',
    'CVE-2015-9251',
    'CVE-2017-0199',
    'CVE-2022-22950',
    'CVE-2017-5715',
    'CVE-2022-26925',
    'CVE-2021-26414',
    'CVE-2017-5638',
    'CVE-2022-26923',
    'CVE-2022-41033',
    'CVE-2023-24880',
    'CVE-2022-0778',
    'CVE-2022-26134',
    'CVE-2021-41773',
    'CVE-2021-23017',
    'CVE-2023-27532',
    'CVE-2021-3156',
    'CVE-2022-42252',
    'CVE-2022-32917',
    'CVE-2023-27350',
    'CVE-2022-23529',
    'CVE-2022-38392',
    'CVE-2022-42856',
    'CVE-2014-4078',
    'CVE-2023-28206',
    'CVE-2022-34305',
    'CVE-2022-22970',
    'CVE-2020-11023',
    'CVE-2007-4559',
    'CVE-2022-29885',
    'CVE-2021-1675',
    'CVE-2022-29143',
    'CVE-2022-41089',
    'CVE-2022-22954',
    'CVE-2022-22963',
    'CVE-2020-36518',
    'CVE-2019-18935',
    'CVE-2022-42004',
    'CVE-2021-41617',
    'CVE-2023-24033',
    'CVE-2022-36804',
    'CVE-2023-32233',
    'CVE-2022-33980',
    'CVE-2022-22720',
    'CVE-2023-25690',
    'CVE-2022-21894',
    'CVE-2023-29336',
    'CVE-2022-40684',
    'CVE-2022-33891',
    'CVE-2022-37966',
    'CVE-2022-42827',
    'CVE-2022-25857',
    'CVE-2022-42475',
    'CVE-2022-21587',
    'CVE-2023-28205',
    'CVE-2022-2526',
    'CVE-2022-23521',
    'CVE-2022-0028',
    'CVE-2023-21823',
    'CVE-2022-41328',
    'CVE-2021-45105',
    'CVE-2023-26360',
    'CVE-2022-22978',
    'CVE-2022-41903',
    'CVE-2022-34721',
    'CVE-2022-26138',
    'CVE-2022-4262',
    'CVE-2022-42898',
    'CVE-2023-25610',
    'CVE-2022-31656',
    'CVE-2022-3723',
    'CVE-2022-4135',
    'CVE-2023-2136',
    'CVE-2022-45688',
    'CVE-2022-23307',
    'CVE-2017-0143',
    'CVE-2022-29499',
    'CVE-2022-45143',
    'CVE-1999-0524',
    'CVE-2021-3177',
    'CVE-2021-34473',
    'CVE-2021-35587',
    'CVE-2015-4000',
    'CVE-2022-27255',
    'CVE-2022-23943',
    'CVE-2004-2761',
    'CVE-2019-11358',
    'CVE-2004-0230',
    'CVE-2022-29464',
    'CVE-2019-14287',
    'CVE-2022-25647',
    'CVE-2023-23376',
    'CVE-2017-6742',
    'CVE-2021-21972',
    'CVE-2022-24785',
    'CVE-2022-44698',
    'CVE-2021-26855',
    'CVE-2022-41099',
    'CVE-2023-21715',
    'CVE-2011-3389',
    'CVE-2018-13379',
    'CVE-2014-0160',
    'CVE-2022-30136',
    'CVE-2021-42287',
    'CVE-2018-3639',
    'CVE-2022-21907',
    'CVE-2021-36260',
    'CVE-2021-26084',
    'CVE-2022-31692',
    'CVE-2014-3566',
    'CVE-2022-40303',
    'CVE-2022-1271',
    'CVE-2023-21839',
    'CVE-2023-20860',
    'CVE-2023-21708',
    'CVE-2023-1017',
    'CVE-2022-4304',
    'CVE-2022-41082',
    'CVE-2015-20107',
    'CVE-2021-46848',
    'CVE-2023-20032',
    'CVE-2022-35737',
    'CVE-2022-2097',
    'CVE-2023-0464',
    'CVE-2021-39144',
    'CVE-2019-0708',
    'CVE-2020-0601',
    'CVE-2023-0215',
    'CVE-2022-3602',
    'CVE-2022-44877',
    'CVE-2021-40539',
    'CVE-2022-2274',
    'CVE-2022-23305',
    'CVE-2022-27664',
    'CVE-2022-31705',
    'CVE-2022-32158',
    'CVE-2022-32250',
    'CVE-2022-36067',
    'CVE-2015-6130',
    'CVE-2022-44704',
    'CVE-1999-0517',
    'CVE-2022-26377',
    'CVE-2023-29017',
    'CVE-2020-3992',
    'CVE-2015-1635',
    'CVE-2022-37972',
    'CVE-2015-6161',
    'CVE-2022-22971',
    'CVE-2022-25762',
    'CVE-2017-5753',
    'CVE-2022-31696',
    'CVE-2019-8457',
    'CVE-2021-26701',
    'CVE-2021-44906',
    'CVE-2021-28041',
    'CVE-2021-3711',
    'CVE-2021-44790',
    'CVE-2022-26500',
    'CVE-2020-14882',
    'CVE-2022-41091',
    'CVE-2020-14145',
    'CVE-2023-29325',
    'CVE-2022-41040',
    'CVE-2022-3515',
    'CVE-2009-3555',
    'CVE-2020-8908',
    'CVE-2021-21551',
    'CVE-2022-47629',
    'CVE-2013-2566',
    'CVE-2022-45061',
    'CVE-2023-24329',
    'CVE-2022-30133',
    'CVE-2020-5902',
    'CVE-2021-42278',
    'CVE-2023-20076',
    'CVE-2022-2884',
    'CVE-2022-28219',
    'CVE-2022-4450',
    'CVE-2021-37533',
    'CVE-2020-1350',
    'CVE-2023-21930',
    'CVE-2022-21540',
    'CVE-2022-41064',
    'CVE-2019-11043',
    'CVE-2022-3171',
    'CVE-2022-41073',
    'CVE-2022-3236',
    'CVE-2023-20861',
    'CVE-2023-21808',
    'CVE-2022-41076',
    'CVE-2022-40152',
    'CVE-2022-26136',
    'CVE-2022-32221',
    'CVE-2023-29552',
    'CVE-2022-47986',
    'CVE-2023-25136',
    'CVE-2022-21449',
    'CVE-2008-5161',
    'CVE-2015-0204',
    'CVE-2017-6549',
    'CVE-2018-0171',
    'CVE-2020-25632',
    'CVE-2020-9488',
    'CVE-2021-43527',
    'CVE-2022-1586',
    'CVE-2022-23302',
    'CVE-2022-31129',
    'CVE-2022-38752',
    'CVE-2022-46169',
    'CVE-2023-1370',
    'CVE-2023-25194',
    'CVE-2021-31207',
    'CVE-2023-28708',
    'CVE-2018-1285',
    'CVE-2020-3580',
    'CVE-2023-29324',
    'CVE-2017-5754',
    'CVE-2018-12126',
    'CVE-2021-42013',
    'CVE-2021-35394',
    'CVE-2021-44142',
    'CVE-2022-1040',
    'CVE-2022-0492',
    'CVE-2023-20863',
    'CVE-2022-0543',
    'CVE-2022-47939',
    'CVE-2022-20968',
    'CVE-2023-21725',
    'CVE-2022-41881',
    'CVE-2022-37958',
    'CVE-2022-40897',
    'CVE-2022-41120',
    'CVE-2022-21123',
    'CVE-2022-41852',
    'CVE-2023-21692',
    'CVE-2021-21985',
    'CVE-2023-0767',
    'CVE-2022-24521',
    'CVE-2017-12617',
    'CVE-2021-20233',
    'CVE-2021-22205',
    'CVE-2022-28391',
    'CVE-2022-3786',
    'CVE-2023-23514',
    'CVE-2023-24055',
    'CVE-2017-13766',
    'CVE-2021-0920',
    'CVE-2021-3517',
    'CVE-2013-4786',
    'CVE-2012-0158',
    'CVE-2021-1636',
    'CVE-2022-46689',
    'CVE-2022-36537',
    'CVE-2023-22374',
    'CVE-2016-5195',
    'CVE-2020-9490',
    'CVE-2021-43890',
    'CVE-2020-10735',
    'CVE-2022-34918',
    'CVE-2022-41622',
    'CVE-2021-24112',
    'CVE-2017-7494',
    'CVE-2022-46364',
    'CVE-2021-26857',
    'CVE-2022-22721',
    'CVE-2021-36942',
    'CVE-2002-20001',
    'CVE-2022-35405',
    'CVE-2022-43680',
    'CVE-2022-24086',
    'CVE-2022-32207',
    'CVE-2022-22972',
    'CVE-2022-36760',
    'CVE-2022-27404',
    'CVE-2022-21882',
    'CVE-2022-41352',
    'CVE-2006-20001',
    'CVE-2023-21830',
    'CVE-2023-24483',
    'CVE-2022-27511',
    'CVE-2022-26135',
    'CVE-2023-22501',
    'CVE-2022-37601',
    'CVE-2023-20026',
    'CVE-2022-34689',
    'CVE-2023-0179',
    'CVE-2022-41723',
    'CVE-2022-41032',
    'CVE-2022-21476',
    'CVE-2022-41125',
    'CVE-2023-28303',
    'CVE-2022-46871',
    'CVE-2022-1996',
    'CVE-2022-23491',
    'CVE-2022-30333',
    'CVE-2022-29154',
    'CVE-2022-40259',
    'CVE-2022-23093',
    'CVE-2016-20012',
    'CVE-2021-41184',
    'CVE-2022-27925',
    'CVE-2022-40304',
    'CVE-2015-6111',
    'CVE-2015-2291',
    'CVE-2023-21557',
    'CVE-2023-27524',
    'CVE-2022-30168',
    'CVE-2019-5544',
    'CVE-2023-27522',
    'CVE-2019-8331',
    'CVE-2022-30134',
    'CVE-2021-22005',
    'CVE-2022-41974',
    'CVE-2022-41049',
    'CVE-2018-8440',
    'CVE-2015-0008',
    'CVE-2022-31159',
    'CVE-2022-34265',
    'CVE-2020-1147',
    'CVE-2023-21549',
    'CVE-2022-28615',
    'CVE-2021-27065',
    'CVE-2022-21166',
    'CVE-2022-35912',
    'CVE-2023-23378',
    'CVE-2021-3493',
    'CVE-2022-1729',
    'CVE-2018-11776',
    'CVE-2019-11510',
    'CVE-2023-24538',
    'CVE-2023-2825',
    'CVE-2021-36934',
    'CVE-2022-22536',
    'CVE-2021-42321',
    'CVE-2019-11135',
    'CVE-2022-0185',
    'CVE-2022-29901',
    'CVE-2023-20873',
    'CVE-2022-3996',
    'CVE-2018-3620',
    'CVE-2023-1018',
    'CVE-2022-37436',
    'CVE-2022-39197',
    'CVE-2022-21541',
    'CVE-2023-21529',
    'CVE-2022-1552',
    'CVE-2022-21500',
    'CVE-2018-0101',
    'CVE-2022-35748',
    'CVE-2022-21445',
    'CVE-2023-24943',
    'CVE-2022-1304',
    'CVE-2022-2048',
    'CVE-2023-28231',
    'CVE-2023-21036',
    'CVE-2022-0609',
    'CVE-2017-5487',
    'CVE-2018-0886',
    'CVE-2020-10188',
    'CVE-2020-35489',
    'CVE-2021-22555',
    'CVE-2021-29425',
    'CVE-2021-34523',
    'CVE-2021-39275',
    'CVE-2021-43798',
    'CVE-2022-1096',
    'CVE-2022-2185',
    'CVE-2022-31626',
    'CVE-2022-32224',
    'CVE-2022-3358',
    'CVE-2022-42915',
    'CVE-2022-33632',
    'CVE-2018-20225',
    'CVE-2017-5892',
    'CVE-2014-0114',
    'CVE-2020-9493',
    'CVE-2023-23384',
    'CVE-2021-26691',
    'CVE-2022-32156',
    'CVE-2022-38045',
    'CVE-2022-22980',
    'CVE-2022-25845',
    'CVE-2022-45868',
    'CVE-2023-27898',
    'CVE-2020-0646',
    'CVE-2022-24823',
    'CVE-2023-21768',
    'CVE-2023-28304',
    'CVE-2007-6750',
    'CVE-2022-22947',
    'CVE-2022-46175',
    'CVE-2022-25315',
    'CVE-2022-24516',
    'CVE-2022-30065',
    'CVE-2022-25235',
    'CVE-2021-22048',
    'CVE-2022-24112',
    'CVE-2022-31625',
    'CVE-2021-3618',
    'CVE-2022-27254',
    'CVE-2008-4250',
    'CVE-2017-10271',
    'CVE-2022-1587',
    'CVE-2022-23806',
    'CVE-2019-6111',
    'CVE-2021-3918',
    'CVE-2020-14750',
    'CVE-2022-40151',
    'CVE-2022-26937',
    'CVE-2022-25168',
    'CVE-2009-3103',
    'CVE-2023-28250',
    'CVE-2020-35169',
    'CVE-2022-24999',
    'CVE-2019-12900',
    'CVE-2019-0232',
    'CVE-2022-46908',
    'CVE-2017-7269',
    'CVE-2019-2725',
    'CVE-2022-32212',
    'CVE-2007-2447',
    'CVE-2022-33894',
    'CVE-2022-28763',
    'CVE-2022-26501',
    'CVE-2022-37971',
    'CVE-2022-21978',
    'CVE-2022-1364',
    'CVE-2022-37042',
    'CVE-2019-0604',
    'CVE-2022-22719',
    'CVE-2022-2625',
    'CVE-2014-0224',
    'CVE-2022-25236',
    'CVE-2019-20372',
    'CVE-2020-11984',
    'CVE-2022-21626',
    'CVE-2022-23181',
    'CVE-2022-24436',
    'CVE-2022-31197',
    'CVE-2022-44268',
    'CVE-2022-26376',
    'CVE-2022-41915',
    'CVE-2023-23914',
    'CVE-2022-34716',
    'CVE-2022-38042',
    'CVE-2022-23816',
    'CVE-2022-1664',
    'CVE-2022-31160',
    'CVE-2023-20078',
    'CVE-2022-38013',
    'CVE-2023-20862',
    'CVE-2022-38177',
    'CVE-2022-4378',
    'CVE-2022-34722',
    'CVE-2023-23752',
    'CVE-2021-3807',
    'CVE-2023-24941',
    'CVE-2022-2586',
    'CVE-2010-4478',
    'CVE-2012-6708',
    'CVE-2020-13956',
    'CVE-2021-23358',
    'CVE-2022-21661',
    'CVE-2022-28614',
    'CVE-2022-29072',
    'CVE-2022-29130',
    'CVE-2022-32149',
    'CVE-2022-41854',
    'CVE-2022-42919',
    'CVE-1999-0519',
    'CVE-2018-8273',
    'CVE-2021-33503',
    'CVE-2021-41182',
    'CVE-2022-23457',
    'CVE-2017-7525',
    'CVE-2022-34398',
    'CVE-2021-43905',
    'CVE-2011-1002',
    'CVE-2017-8759',
    'CVE-2022-20920',
    'CVE-2021-44224',
    'CVE-2022-3890',
    'CVE-2021-21315',
    'CVE-2022-22977',
    'CVE-2022-29155',
    'CVE-2023-21608',
    'CVE-2022-31699',
    'CVE-2022-23219',
    'CVE-2018-1270',
    'CVE-2021-29921',
    'CVE-2023-28260',
    'CVE-2023-20025',
    'CVE-2021-22569',
    'CVE-2023-32409',
    'CVE-2022-45047',
    'CVE-2022-21426',
    'CVE-2022-33679',
    'CVE-2022-42969',
    'CVE-2022-1012',
    'CVE-2015-2808',
    'CVE-2022-29458',
    'CVE-2022-0391',
    'CVE-2019-16905',
    'CVE-2012-2399',
    'CVE-2022-30216',
    'CVE-2021-31166',
    'CVE-2022-22968',
    'CVE-2022-24765',
    'CVE-2021-23337',
    'CVE-2019-9053',
    'CVE-2021-22986',
    'CVE-2022-21628',
    'CVE-2022-29404',
    'CVE-2022-22982',
    'CVE-2019-1652',
    'CVE-2021-3129',
    'CVE-2022-23222',
    'CVE-2021-38297',
    'CVE-2022-29900',
    'CVE-2017-3167',
    'CVE-2022-22822',
    'CVE-2021-45960',
    'CVE-2020-0688',
    'CVE-2021-41379',
    'CVE-2022-31693',
    'CVE-2022-3289',
    'CVE-2021-25220',
    'CVE-2022-3517',
    'CVE-2021-26858',
    'CVE-2022-24407',
    'CVE-2022-35914',
    'CVE-2022-3590',
    'CVE-2023-21835',
    'CVE-2021-34481',
    'CVE-2021-43980',
    'CVE-2023-21689',
    'CVE-2023-21843',
    'CVE-2022-47523',
    'CVE-2023-21752',
    'CVE-2022-2509',
    'CVE-2022-31690',
    'CVE-2023-28432',
    'CVE-2022-28733',
    'CVE-2023-23392',
    'CVE-2023-23916',
    'CVE-2022-3715',
    'CVE-2022-41674',
    'CVE-2023-20864',
    'CVE-2022-28199',
    'CVE-2022-2795',
    'CVE-2022-25881',
    'CVE-2022-42920',
    'CVE-2022-3643',
    'CVE-2023-23560',
    'CVE-2022-41717',
    'CVE-2023-26359',
    'CVE-2023-21707',
    'CVE-2022-4203',
    'CVE-2022-26137',
    'CVE-2022-21233',
    'CVE-2020-3187',
    'CVE-2022-31706',
    'CVE-2022-3038',
    'CVE-2021-33909',
    'CVE-2022-34691',
    'CVE-2022-32744',
    'CVE-2022-1966',
    'CVE-2022-32548',
    'CVE-2022-27924',
    'CVE-2023-28771',
    'CVE-2022-2602',
    'CVE-2011-3192',
    'CVE-2002-1623',
    'CVE-2016-8735',
    'CVE-2017-7679',
    'CVE-2018-15919',
    'CVE-2019-5736',
    'CVE-2020-10713',
    'CVE-2020-13936',
    'CVE-2020-14179',
    'CVE-2021-26291',
    'CVE-2021-31206',
    'CVE-2021-31805',
    'CVE-2021-34798',
    'CVE-2021-35211',
    'CVE-2021-36368',
    'CVE-2021-42392',
    'CVE-2021-42550',
    'CVE-2021-4277',
    'CVE-2022-24903',
    'CVE-2022-33915',
    'CVE-2022-36944',
    'CVE-2022-41741',
    'CVE-2022-43551',
    'CVE-2023-25725',
    'CVE-2023-28154',
    'CVE-2023-28531',
    'CVE-2023-2868',
    'CVE-2022-30173',
    'CVE-2022-26352',
    'CVE-2022-39299',
    'CVE-2001-1473',
    'CVE-2010-3190',
    'CVE-2022-29149',
    'CVE-2017-15906',
    'CVE-2019-11068',
    'CVE-2015-2590',
    'CVE-2022-0004',
    'CVE-2022-29361',
    'CVE-2013-3587',
    'CVE-2016-3427',
    'CVE-2021-30860',
    'CVE-2021-27568',
    'CVE-2019-1559',
    'CVE-2022-2047',
    'CVE-2021-46145',
    'CVE-2022-31630',
    'CVE-2021-41183',
    'CVE-2018-7489',
    'CVE-2020-10148',
    'CVE-2010-3972',
    'CVE-2010-2730',
    'CVE-2022-22620',
    'CVE-2022-30556',
    'CVE-2018-0802',
    'CVE-2017-9841',
    'CVE-2020-17530',
    'CVE-2021-22570',
    'CVE-2022-26904',
    'CVE-2023-24484',
    'CVE-2020-10189',
    'CVE-2022-28810',
    'CVE-2022-21841',
    'CVE-2022-30522',
    'CVE-2018-20685',
    'CVE-2017-8543',
    'CVE-2022-20812',
    'CVE-2014-7169',
    'CVE-2016-7406',
    'CVE-2013-0169',
    'CVE-2020-11896',
    'CVE-2020-5741',
    'CVE-2021-23450',
    'CVE-2019-19814',
    'CVE-2022-43781',
    'CVE-2022-28755',
    'CVE-2021-40449',
    'CVE-2022-21980',
    'CVE-2010-2568',
    'CVE-2022-44710',
    'CVE-2020-26116',
    'CVE-2021-28861',
    'CVE-2019-20916',
    'CVE-2023-29343',
    'CVE-2021-30640',
    'CVE-2022-21371',
    'CVE-2023-21538',
    'CVE-2020-27619',
    'CVE-2020-0618',
    'CVE-2022-26832',
    'CVE-2020-5408',
    'CVE-2020-10683',
    'CVE-2022-31629',
    'CVE-2022-39253',
    'CVE-2018-8120',
    'CVE-2022-25844',
    'CVE-2018-2628',
    'CVE-2022-21503',
    'CVE-2016-4658',
    'CVE-2022-43553',
    'CVE-2021-43138',
    'CVE-2021-38647',
    'CVE-2021-42292',
    'CVE-2023-20010',
    'CVE-2022-27782',
    'CVE-2021-1647',
    'CVE-2022-2639',
    'CVE-2019-10086',
    'CVE-2022-20713',
    'CVE-2022-21125',
    'CVE-2019-15107',
    'CVE-2021-42340',
    'CVE-2022-21999',
    'CVE-2022-36934',
    'CVE-2022-23823',
    'CVE-2020-15999',
    'CVE-2022-23852',
    'CVE-2023-20159',
    'CVE-2022-42703',
    'CVE-2022-20866',
    'CVE-2023-20858',
    'CVE-2018-14721',
    'CVE-2021-36958',
    'CVE-2017-5689',
    'CVE-2022-27509',
    'CVE-2022-27516',
    'CVE-2022-28330',
    'CVE-2022-22012',
    'CVE-2021-25329',
    'CVE-2022-38463',
    'CVE-2023-23399',
    'CVE-2022-27191',
    'CVE-2022-3509',
    'CVE-2022-27513',
    'CVE-2018-12130',
    'CVE-2023-21705',
    'CVE-2022-21619',
    'CVE-2022-41946',
    'CVE-2022-41716',
    'CVE-2022-47522',
    'CVE-2022-31628',
    'CVE-2022-2964',
    'CVE-2022-21618',
    'CVE-2023-21746',
    'CVE-2022-25147',
    'CVE-2022-32168',
    'CVE-2023-20869',
    'CVE-2022-21198',
    'CVE-2023-23931',
    'CVE-2022-21698',
    'CVE-2023-1707',
    'CVE-2022-41862',
    'CVE-2022-30704',
    'CVE-2019-15271',
    'CVE-2022-24990',
    'CVE-2022-40664',
    'CVE-2022-36883',
    'CVE-2022-23960',
    'CVE-2023-0465',
    'CVE-2022-21549',
    'CVE-2015-5600',
    'CVE-2022-32190',
    'CVE-2023-29491',
    'CVE-2023-0466',
    'CVE-2022-3064',
    'CVE-2022-30123',
    'CVE-2022-1680',
    'CVE-2019-20444',
    'CVE-2022-38048',
    'CVE-2022-35744',
    'CVE-2022-3970',
    'CVE-2022-23825',
    'CVE-2022-38178',
    'CVE-2021-3999',
    'CVE-2022-27596',
    'CVE-2023-0401',
    'CVE-2020-12440',
    'CVE-2022-22960',
    'CVE-2022-35252',
    'CVE-2023-21690',
    'CVE-2022-25765',
    'CVE-2022-22038',
    'CVE-2022-3172',
    'CVE-2022-22576',
    'CVE-2017-7529',
    'CVE-2023-27351',
    'CVE-2019-13272',
    'CVE-2022-32894',
    'CVE-2023-2004',
    'CVE-2017-11317',
    'CVE-2022-26485',
    'CVE-2011-1473',
    'CVE-2015-6420',
    'CVE-2015-7501',
    'CVE-2017-3169',
    'CVE-2017-3881',
    'CVE-2019-10172',
    'CVE-2020-14343',
    'CVE-2020-2551',
    'CVE-2021-40690',
    'CVE-2021-41091',
    'CVE-2022-1941',
    'CVE-2022-21496',
    'CVE-2022-21724',
    'CVE-2022-22943',
    'CVE-2022-23218',
    'CVE-2022-24434',
    'CVE-2022-24706',
    'CVE-2022-2852',
    'CVE-2022-29824',
    'CVE-2022-30525',
    'CVE-2022-34301',
    'CVE-2022-37026',
    'CVE-2022-41800',
    'CVE-2022-41853',
    'CVE-2022-42916',
    'CVE-2022-43548',
    'CVE-2023-0361',
    'CVE-2023-26464',
    'CVE-2016-7288',
    'CVE-2021-38507',
    'CVE-2018-8877',
    'CVE-2011-2523',
    'CVE-1999-0511',
    'CVE-2019-1010022',
    'CVE-2016-6329',
    'CVE-2022-31680',
    'CVE-2020-25638',
    'CVE-2012-4929',
    'CVE-2017-6548',
    'CVE-2022-30141',
    'CVE-2022-32532',
    'CVE-2017-11357',
    'CVE-2012-1823',
    'CVE-2016-10009',
    'CVE-1999-0512',
    'CVE-2022-37452',
    'CVE-2022-31704',
    'CVE-2017-9805',
    'CVE-2022-30209',
    'CVE-2022-47211',
    'CVE-2014-8985',
    'CVE-1999-0526',
    'CVE-2022-20964',
    'CVE-2015-4902',
    'CVE-2020-26137',
    'CVE-2020-3433',
    'CVE-2022-22718',
    'CVE-2022-28948',
    'CVE-2022-37976',
    'CVE-2022-40149',
    'CVE-2011-1249',
    'CVE-2022-44721',
    'CVE-2022-24491',
    'CVE-2020-5735',
    'CVE-2019-0820',
    'CVE-2022-2309',
    'CVE-2022-30221',
    'CVE-2021-3737',
    'CVE-2022-22976',
    'CVE-2022-39260',
    'CVE-2018-0798',
    'CVE-2016-1585',
    'CVE-2020-12812',
    'CVE-2017-0145',
    'CVE-2022-21979',
    'CVE-2022-43995',
    'CVE-2022-23267',
    'CVE-2022-23267',
    'CVE-2022-31697',
    'CVE-2022-31697',
    'CVE-2021-21017',
    'CVE-2021-21017',
    'CVE-2020-8218',
    'CVE-2020-8218',
    'CVE-2022-30130',
    'CVE-2022-30130',
    'CVE-2020-0605',
    'CVE-2020-0605',
    'CVE-2017-6862',
    'CVE-2017-6862',
    'CVE-2022-0435',
    'CVE-2022-0435',
    'CVE-2018-16763',
    'CVE-2018-16763',
    'CVE-2015-3306',
    'CVE-2015-3306',
    'CVE-2022-30184',
    'CVE-2022-30184',
    'CVE-2018-14847',
    'CVE-2018-14847',
    'CVE-2023-27530',
    'CVE-2023-27530',
    'CVE-2023-28879',
    'CVE-2023-28879',
    'CVE-2021-33574',
    'CVE-2021-33574',
    'CVE-2019-1388',
    'CVE-2019-1388',
    'CVE-2016-4437',
    'CVE-2016-4437',
    'CVE-2021-23840',
    'CVE-2021-23840',
    'CVE-2022-25636',
    'CVE-2022-25636',
    'CVE-2023-28311',
    'CVE-2023-28311',
    'CVE-2023-23530',
    'CVE-2023-23530',
    'CVE-2020-13091',
    'CVE-2020-13091',
    'CVE-2022-34903',
    'CVE-2022-34903',
    'CVE-2021-23926',
    'CVE-2021-23926',
    'CVE-2021-3803',
    'CVE-2021-3803',
    'CVE-2022-26931',
    'CVE-2022-26931',
    'CVE-2013-5211',
    'CVE-2013-5211',
    'CVE-2020-1971',
    'CVE-2020-1971',
    'CVE-2021-37137',
    'CVE-2021-37137',
    'CVE-2015-1641',
    'CVE-2015-1641',
    'CVE-2022-33987',
    'CVE-2022-33987',
    'CVE-2021-21703',
    'CVE-2021-21703',
    'CVE-2020-1002',
    'CVE-2020-1002',
    'CVE-2017-0147',
    'CVE-2017-0147',
    'CVE-2023-21743',
    'CVE-2023-21743',
    'CVE-2022-23282',
    'CVE-2022-23282',
    'CVE-2022-29117',
    'CVE-2022-29117',
    'CVE-2022-23270',
    'CVE-2022-23270',
    'CVE-2019-10744',
    'CVE-2019-10744',
    'CVE-2020-1935',
    'CVE-2020-1935',
    'CVE-2022-43945',
    'CVE-2022-43945',
    'CVE-2019-1161',
    'CVE-2019-1161',
    'CVE-2022-41742',
    'CVE-2022-41742',
    'CVE-2020-7676',
    'CVE-2020-7676',
    'CVE-2021-3426',
    'CVE-2021-3426',
    'CVE-2022-26612',
    'CVE-2022-26612',
    'CVE-2022-36946',
    'CVE-2022-36946',
    'CVE-2023-32243',
    'CVE-2023-32243',
    'CVE-2021-44716',
    'CVE-2021-44716',
    'CVE-2019-17567',
    'CVE-2019-17567',
    'CVE-2021-1732',
    'CVE-2021-1732',
    'CVE-2021-3449',
    'CVE-2021-3449',
    'CVE-2022-22041',
    'CVE-2022-22041',
    'CVE-2021-22600',
    'CVE-2021-22600',
    'CVE-2022-21443',
    'CVE-2022-21443',
    'CVE-2018-8174',
    'CVE-2018-8174',
    'CVE-2022-20465',
    'CVE-2022-20465',
    'CVE-2022-25631',
    'CVE-2022-25631',
    'CVE-2016-6662',
    'CVE-2016-6662',
    'CVE-2019-2215',
    'CVE-2019-2215',
    'CVE-2021-36325',
    'CVE-2021-36325',
    'CVE-2022-29581',
    'CVE-2022-29581',
    'CVE-2021-4154',
    'CVE-2021-4154',
    'CVE-2020-16156',
    'CVE-2020-16156',
    'CVE-2019-6340',
    'CVE-2019-6340',
    'CVE-2022-38751',
    'CVE-2022-38751',
    'CVE-2015-7547',
    'CVE-2015-7547',
    'CVE-2022-23277',
    'CVE-2022-23277',
    'CVE-2018-14040',
    'CVE-2018-14040',
    'CVE-2021-35942',
    'CVE-2021-35942',
    'CVE-2022-43571',
    'CVE-2022-43571',
    'CVE-2022-38749',
    'CVE-2022-38749',
    'CVE-2016-6210',
    'CVE-2016-6210',
    'CVE-2021-39537',
    'CVE-2021-39537',
    'CVE-2022-21898',
    'CVE-2022-21898',
    'CVE-2019-3396',
    'CVE-2019-3396',
    'CVE-2021-36090',
    'CVE-2021-36090',
    'CVE-2022-27600',
    'CVE-2022-27600',
    'CVE-2021-1730',
    'CVE-2021-1730',
    'CVE-2021-22204',
    'CVE-2021-22204',
    'CVE-2023-0662',
    'CVE-2023-0662',
    'CVE-2022-26929',
    'CVE-2022-26929',
    'CVE-2019-7304',
    'CVE-2019-7304',
    'CVE-2022-24477',
    'CVE-2022-24477',
    'CVE-2023-2721',
    'CVE-2023-2721',
    'CVE-2023-24486',
    'CVE-2023-24486',
    'CVE-2022-22824',
    'CVE-2022-22824',
    'CVE-2022-22823',
    'CVE-2022-22823',
    'CVE-2021-3064',
    'CVE-2021-3064',
    'CVE-2020-0733',
    'CVE-2020-0733',
    'CVE-2014-6278',
    'CVE-2014-6278',
    'CVE-2023-22490',
    'CVE-2023-22490',
    'CVE-2022-3821',
    'CVE-2022-3821',
    'CVE-2022-30339',
    'CVE-2022-30339',
    'CVE-2022-23990',
    'CVE-2022-23990',
    'CVE-2022-41923',
    'CVE-2022-41923',
    'CVE-2022-36033',
    'CVE-2022-36033',
    'CVE-2022-21151',
    'CVE-2022-21151',
    'CVE-2023-21726',
    'CVE-2023-21726',
    'CVE-2022-41721',
    'CVE-2022-41721',
    'CVE-2021-34429',
    'CVE-2021-34429',
    'CVE-2021-33037',
    'CVE-2021-33037',
    'CVE-2018-90017117',
    'CVE-2018-90017117',
    'CVE-2022-22047',
    'CVE-2022-22047',
    'CVE-2023-1255',
    'CVE-2023-1255',
    'CVE-2022-40150',
    'CVE-2022-40150',
    'CVE-2023-24485',
    'CVE-2023-24485',
    'CVE-2022-20798',
    'CVE-2022-20798',
    'CVE-2022-24439',
    'CVE-2022-24439',
    'CVE-2022-32832',
    'CVE-2022-32832',
    'CVE-2022-31569',
    'CVE-2022-31569',
    'CVE-2022-20822',
    'CVE-2022-20822',
    'CVE-2022-21499',
    'CVE-2022-21499',
    'CVE-2022-3437',
    'CVE-2022-3437',
    'CVE-2022-40898',
    'CVE-2022-40898',
    'CVE-2022-36437',
    'CVE-2022-36437',
    'CVE-2015-0235',
    'CVE-2015-0235',
    'CVE-2022-21624',
    'CVE-2022-21624',
    'CVE-2021-42291',
    'CVE-2021-42291',
    'CVE-2016-1000031',
    'CVE-2016-1000031',
    'CVE-2022-48303',
    'CVE-2022-48303',
    'CVE-2020-5398',
    'CVE-2020-5398',
    'CVE-2016-3709',
    'CVE-2016-3709',
    'CVE-2023-23946',
    'CVE-2023-23946',
    'CVE-2023-0842',
    'CVE-2023-0842',
    'CVE-2022-3649',
    'CVE-2022-3649',
    'CVE-2022-22241',
    'CVE-2022-22241',
    'CVE-2022-41953',
    'CVE-2022-41953',
    'CVE-2022-31631',
    'CVE-2022-31631',
    'CVE-2021-34484',
    'CVE-2021-34484',
    'CVE-2022-25858',
    'CVE-2022-25858',
    'CVE-2022-4254',
    'CVE-2022-4254',
    'CVE-2023-24934',
    'CVE-2023-24934',
    'CVE-2022-32511',
    'CVE-2022-32511',
    'CVE-2021-35065',
    'CVE-2021-35065',
    'CVE-2022-3510',
    'CVE-2022-3510',
    'CVE-2022-29599',
    'CVE-2022-29599',
    'CVE-2022-35698',
    'CVE-2022-35698',
    'CVE-2023-20963',
    'CVE-2023-20963',
    'CVE-2023-2251',
    'CVE-2023-2251',
    'CVE-2022-2879',
    'CVE-2022-2879',
    'CVE-2023-20052',
    'CVE-2023-20052',
    'CVE-2023-20079',
    'CVE-2023-20079',
    'CVE-2021-38561',
    'CVE-2021-38561',
    'CVE-2018-1312',
    'CVE-2018-1312',
    'CVE-2023-0696',
    'CVE-2023-0696',
    'CVE-2022-40242',
    'CVE-2022-40242',
    'CVE-2022-26928',
    'CVE-2022-26928',
    'CVE-2023-20883',
    'CVE-2023-20883',
    'CVE-2021-46828',
    'CVE-2021-46828',
    'CVE-2022-0934',
    'CVE-2022-0934',
    'CVE-2021-3572',
    'CVE-2021-3572',
    'CVE-2022-32213',
    'CVE-2022-32213',
    'CVE-2022-31474',
    'CVE-2022-31474',
    'CVE-2023-21803',
    'CVE-2023-21803',
    'CVE-2022-31685',
    'CVE-2022-31685',
    'CVE-2021-35464',
    'CVE-2021-35464',
    'CVE-2022-32189',
    'CVE-2022-32189',
    'CVE-2022-3656',
    'CVE-2022-3656',
    'CVE-2022-41043',
    'CVE-2022-41043',
    'CVE-2022-40153',
    'CVE-2022-40153',
    'CVE-2022-2156',
    'CVE-2022-2156',
    'CVE-2021-20316',
    'CVE-2021-20316',
    'CVE-2022-22675',
    'CVE-2022-22675',
    'CVE-2021-20038',
    'CVE-2021-20038',
    'CVE-2022-32206',
    'CVE-2022-32206',
    'CVE-2022-1802',
    'CVE-2022-1802',
    'CVE-2023-28204',
    'CVE-2023-28204',
    'CVE-2022-30170',
    'CVE-2022-30170',
    'CVE-2023-1389',
    'CVE-2023-1389',
    'CVE-2022-35803',
    'CVE-2022-35803',
    'CVE-2021-26401',
    'CVE-2021-26401',
    'CVE-2022-23308',
    'CVE-2022-23308',
    'CVE-2022-32215',
    'CVE-2022-32215',
    'CVE-2022-4883',
    'CVE-2022-4883',
    'CVE-2016-7103',
    'CVE-2016-7103',
    'CVE-2022-2585',
    'CVE-2022-2585',
    'CVE-2022-0839',
    'CVE-2022-0839',
    'CVE-2000-1200',
    'CVE-2000-1200',
    'CVE-2005-2541',
    'CVE-2005-2541',
    'CVE-2010-0386',
    'CVE-2010-0386',
    'CVE-2011-4969',
    'CVE-2011-4969',
    'CVE-2015-4852',
    'CVE-2015-4852',
    'CVE-2015-5237',
    'CVE-2015-5237',
    'CVE-2017-0148',
    'CVE-2017-0148',
    'CVE-2017-18640',
    'CVE-2017-18640',
    'CVE-2017-5645',
    'CVE-2017-5645',
    'CVE-2017-6168',
    'CVE-2017-6168',
    'CVE-2017-8570',
    'CVE-2017-8570',
    'CVE-2017-9798',
    'CVE-2017-9798',
    'CVE-2018-13382',
    'CVE-2018-13382',
    'CVE-2018-19052',
    'CVE-2018-19052',
    'CVE-2019-0227',
    'CVE-2019-0227',
    'CVE-2019-10202',
    'CVE-2019-10202',
    'CVE-2019-11248',
    'CVE-2019-11248',
    'CVE-2019-17558',
    'CVE-2019-17558',
    'CVE-2019-20445',
    'CVE-2019-20445',
    'CVE-2019-2729',
    'CVE-2019-2729',
    'CVE-2019-5786',
    'CVE-2019-5786',
    'CVE-2020-1020',
    'CVE-2020-1020',
    'CVE-2020-10663',
    'CVE-2020-10663',
    'CVE-2020-15250',
    'CVE-2020-15250',
    'CVE-2020-25649',
    'CVE-2020-25649',
    'CVE-2020-28052',
    'CVE-2020-28052',
    'CVE-2021-21708',
    'CVE-2021-21708',
    'CVE-2021-2388',
    'CVE-2021-2388',
    'CVE-2021-26897',
    'CVE-2021-26897',
    'CVE-2021-28165',
    'CVE-2021-28165',
    'CVE-2021-3060',
    'CVE-2021-3060',
    'CVE-2021-34141',
    'CVE-2021-34141',
    'CVE-2021-37136',
    'CVE-2021-37136',
    'CVE-2021-42574',
    'CVE-2021-42574',
    'CVE-2021-44077',
    'CVE-2021-44077',
    'CVE-2022-20829',
    'CVE-2022-20829',
    'CVE-2022-21664',
    'CVE-2022-21664',
    'CVE-2022-23131',
    'CVE-2022-23131',
    'CVE-2022-23221',
    'CVE-2022-23221',
    'CVE-2022-23437',
    'CVE-2022-23437',
    'CVE-2022-27666',
    'CVE-2022-27666',
    'CVE-2022-29078',
    'CVE-2022-29078',
    'CVE-2022-29187',
    'CVE-2022-29187',
    'CVE-2022-29217',
    'CVE-2022-29217',
    'CVE-2022-34917',
    'CVE-2022-34917',
    'CVE-2022-41715',
    'CVE-2022-41715',
    'CVE-2022-42719',
    'CVE-2022-42719',
    'CVE-2022-42821',
    'CVE-2022-42821',
    'CVE-2023-24059',
    'CVE-2023-24059',
    'CVE-2023-32373',
    'CVE-2023-32373',
    'CVE-2014-2801',
    'CVE-2014-2801',
    'CVE-2020-3120',
    'CVE-2020-3120',
    'CVE-2019-6576',
    'CVE-2019-6576',
    'CVE-2013-1609',
    'CVE-2013-1609',
    'CVE-2023-27905',
    'CVE-2023-27905',
    'CVE-2022-34303',
    'CVE-2022-34303',
    'CVE-2002-1117',
    'CVE-2002-1117',
    'CVE-2008-1275',
    'CVE-2008-1275',
    'CVE-2018-8088',
    'CVE-2018-8088',
    'CVE-2017-12626',
    'CVE-2017-12626',
    'CVE-2022-41325',
    'CVE-2022-41325',
    'CVE-2022-21874',
    'CVE-2022-21874',
    'CVE-2016-1908',
    'CVE-2016-1908',
    'CVE-2022-29526',
    'CVE-2022-29526',
    'CVE-2019-6110',
    'CVE-2019-6110',
    'CVE-2011-3416',
    'CVE-2011-3416',
    'CVE-2023-23638',
    'CVE-2023-23638',
    'CVE-2021-3331',
    'CVE-2021-3331',
    'CVE-2022-38750',
    'CVE-2022-38750',
    'CVE-2017-18214',
    'CVE-2017-18214',
    'CVE-2021-34464',
    'CVE-2021-34464',
    'CVE-2008-0166',
    'CVE-2008-0166',
    'CVE-2017-5646',
    'CVE-2017-5646',
    'CVE-2004-2320',
    'CVE-2004-2320',
    'CVE-2021-46101',
    'CVE-2021-46101',
    'CVE-2020-7656',
    'CVE-2020-7656',
    'CVE-2021-32036',
    'CVE-2021-32036',
    'CVE-2020-15522',
    'CVE-2020-15522',
    'CVE-2022-21851',
    'CVE-2022-21851',
    'CVE-2023-0567',
    'CVE-2023-0567',
    'CVE-2017-17215',
    'CVE-2017-17215',
    'CVE-2015-1701',
    'CVE-2015-1701',
    'CVE-2021-28216',
    'CVE-2021-28216',
    'CVE-2014-6287',
    'CVE-2014-6287',
    'CVE-2022-26336',
    'CVE-2022-26336',
    'CVE-2017-12240',
    'CVE-2017-12240',
    'CVE-2022-30187',
    'CVE-2022-30187',
    'CVE-2020-28196',
    'CVE-2020-28196',
    'CVE-2022-2992',
    'CVE-2022-2992',
    'CVE-2020-29652',
    'CVE-2020-29652',
    'CVE-2020-17003',
    'CVE-2020-17003',
    'CVE-2014-4113',
    'CVE-2014-4113',
    'CVE-2008-3844',
    'CVE-2008-3844',
    'CVE-2022-24329',
    'CVE-2022-24329',
    'CVE-2020-7961',
    'CVE-2020-7961',
    'CVE-2022-26504',
    'CVE-2022-26504',
    'CVE-2021-33764',
    'CVE-2021-33764',
    'CVE-2017-15713',
    'CVE-2017-15713',
    'CVE-2019-9511',
    'CVE-2019-9511',
    'CVE-2022-29972',
    'CVE-2022-29972',
    'CVE-2022-1473',
    'CVE-2022-1473',
    'CVE-2017-15095',
    'CVE-2017-15095',
    'CVE-2006-0987',
    'CVE-2006-0987',
    'CVE-2020-35452',
    'CVE-2020-35452',
    'CVE-2023-32369',
    'CVE-2023-32369',
    'CVE-2022-33186',
    'CVE-2022-33186',
    'CVE-2005-3299',
    'CVE-2005-3299',
    'CVE-2016-9841',
    'CVE-2016-9841',
    'CVE-2003-1418',
    'CVE-2003-1418',
    'CVE-2012-1889',
    'CVE-2012-1889',
    'CVE-2021-0341',
    'CVE-2021-0341',
    'CVE-2021-43208',
    'CVE-2021-43208',
    'CVE-2021-23214',
    'CVE-2021-23214',
    'CVE-2020-26160',
    'CVE-2020-26160',
    'CVE-2019-1322',
    'CVE-2019-1322',
    'CVE-2021-42298',
    'CVE-2021-42298',
    'CVE-2020-8554',
    'CVE-2020-8554',
    'CVE-2019-10768',
    'CVE-2019-10768',
    'CVE-2016-7407',
    'CVE-2016-7407',
    'CVE-2016-0777',
    'CVE-2016-0777',
    'CVE-2020-36242',
    'CVE-2020-36242',
    'CVE-2017-0146',
    'CVE-2017-0146',
    'CVE-2022-26691',
    'CVE-2020-14883',
    'CVE-2022-37439',
    'CVE-2021-26411',
    'CVE-2020-1046',
    'CVE-2018-8292',
    'CVE-2018-8878',
    'CVE-2021-21224',
    'CVE-2022-21917',
    'CVE-2015-1642',
    'CVE-2021-37714',
    'CVE-2018-10933',
    'CVE-2019-6109',
    'CVE-2020-5344',
    'CVE-2021-44731',
    'CVE-2022-21911',
    'CVE-2021-30858',
    'CVE-2022-22035',
    'CVE-2018-9206',
    'CVE-2017-16995',
    'CVE-2018-15982',
    'CVE-2022-29110',
    'CVE-2022-20681',
    'CVE-2021-20090',
    'CVE-2021-22045',
    'CVE-2021-22040',
    'CVE-2022-24457',
    'CVE-2020-15505',
    'CVE-2019-7481',
    'CVE-2022-24497',
    'CVE-2020-13935',
    'CVE-2014-4114',
    'CVE-2020-6287',
    'CVE-2021-22112',
    'CVE-2022-39135',
    'CVE-2021-31684',
    'CVE-2020-7774',
    'CVE-2012-1723',
    'CVE-2011-3544',
    'CVE-2018-1000861',
    'CVE-2023-0568',
    'CVE-2018-16843',
    'CVE-2017-6547',
    'CVE-2017-12754',
    'CVE-2020-1476',
    'CVE-2022-29970',
    'CVE-2022-21849',
    'CVE-2021-20016',
    'CVE-2023-28283',
    'CVE-2022-21919',
    'CVE-2018-8172',
    'CVE-2022-42720',
    'CVE-2021-43045',
    'CVE-2022-45907',
    'CVE-2022-27778',
    'CVE-2022-31678',
    'CVE-2012-0002',
    'CVE-2003-1567',
    'CVE-2022-26706',
    'CVE-2021-3749',
    'CVE-2022-30580',
    'CVE-2021-25122',
    'CVE-2021-38646',
    'CVE-2022-24512',
    'CVE-2020-28928',
    'CVE-2018-8373',
    'CVE-2022-30139',
    'CVE-2018-10561',
    'CVE-2023-23531',
    'CVE-2023-29489',
    'CVE-2016-2781',
    'CVE-2020-12321',
    'CVE-2021-21973',
    'CVE-2019-10068',
    'CVE-2020-1045',
    'CVE-2022-37451',
    'CVE-2017-12149',
    'CVE-2023-21563',
    'CVE-2023-0941',
    'CVE-2021-44515',
    'CVE-2023-29827',
    'CVE-2012-5783',
    'CVE-2017-5929',
    'CVE-2019-9193',
    'CVE-2022-1162',
    'CVE-2022-22784',
    'CVE-2022-32493',
    'CVE-2018-8014',
    'CVE-2021-26690',
    'CVE-2022-40146',
    'CVE-2021-26085',
    'CVE-2021-22573',
    'CVE-2022-42896',
    'CVE-2022-0995',
    'CVE-2023-25577',
    'CVE-2019-1040',
    'CVE-2020-14871',
    'CVE-2022-20345',
    'CVE-2020-1380',
    'CVE-2022-32230',
    'CVE-2022-2078',
    'CVE-2022-41048',
    'CVE-2014-6324',
    'CVE-2018-6389',
    'CVE-2021-42377',
    'CVE-2016-0800',
    'CVE-2021-33560',
    'CVE-2013-4235',
    'CVE-2016-10735',
    'CVE-2021-41079',
    'CVE-2019-9513',
    'CVE-2016-10033',
    'CVE-2023-21893',
    'CVE-2021-41495',
    'CVE-2015-7450',
    'CVE-2016-2118',
    'CVE-2021-42237',
    'CVE-2022-3365',
    'CVE-2022-26488',
    'CVE-2018-8453',
    'CVE-2014-6321',
    'CVE-2022-20699',
    'CVE-2022-38900',
    'CVE-2016-8858',
    'CVE-2021-36222',
    'CVE-2020-3556',
    'CVE-2022-27507',
    'CVE-2021-25216',
    'CVE-2021-22945',
    'CVE-2021-21707',
    'CVE-2022-44666',
    'CVE-2022-28739',
    'CVE-2021-22681',
    'CVE-2019-19768',
    'CVE-2020-158',
    'CVE-2022-22948',
    'CVE-2019-9674',
    'CVE-2021-3490',
    'CVE-2023-24860',
    'CVE-2022-41121',
    'CVE-2018-12127',
    'CVE-2022-34717',
    'CVE-2022-35254',
    'CVE-2023-21745',
    'CVE-2022-307',
    'CVE-2021-38314',
    'CVE-2021-22096',
    'CVE-2021-44521',
    'CVE-2023-22952',
    'CVE-2022-27776',
    'CVE-2021-43565',
    'CVE-2017-11826',
    'CVE-2023-21931',
    'CVE-2020-36569',
    'CVE-2022-27781',
    'CVE-2018-18955',
    'CVE-2015-0254',
    'CVE-2022-23540',
    'CVE-2021-20190',
    'CVE-2021-43618',
    'CVE-2019-25013',
    'CVE-2022-27774',
    'CVE-2022-26788',
    'CVE-2021-1678',
    'CVE-2023-21712',
    'CVE-2015-0932',
    'CVE-2023-23477',
    'CVE-2022-27772',
    'CVE-2021-38003',
    'CVE-2022-44702',
    'CVE-2022-21181',
    'CVE-2022-41034',
    'CVE-2017-9791',
    'CVE-2021-46143',
    'CVE-2022-3019',
    'CVE-2022-37603',
    'CVE-2021-30465',
    'CVE-2022-21972',
    'CVE-2021-24122',
    'CVE-2021-22946',
    'CVE-2022-2421',
    'CVE-2023-24487',
    'CVE-2023-21713',
    'CVE-2022-0739',
    'CVE-2023-21722',
    'CVE-2022-33640',
    'CVE-2022-4065',
    'CVE-2023-0471',
    'CVE-2021-43529',
    'CVE-2022-37599',
    'CVE-2022-1927',
    'CVE-2023-21706',
    'CVE-2020-35527',
    'CVE-2022-3430',
    'CVE-2020-28469',
    'CVE-2022-40899',
    'CVE-2021-43267',
    'CVE-2022-30790',
    'CVE-2020-1927',
    'CVE-2022-37734',
    'CVE-2022-41724',
    'CVE-2022-2191',
    'CVE-2022-0001',
    'CVE-2021-43797',
    'CVE-2022-36227',
    'CVE-2022-2031',
    'CVE-2022-20821',
    'CVE-2022-32214',
    'CVE-2023-21528',
    'CVE-2022-32208',
    'CVE-2023-29469',
    'CVE-2022-22280',
    'CVE-2021-20028',
    'CVE-2019-19781',
    'CVE-2023-21684',
    'CVE-2020-10693',
    'CVE-2022-31702',
    'CVE-2021-4189',
    'CVE-2022-2601',
    'CVE-2022-2477',
    'CVE-2022-45141',
    'CVE-2022-0030',
    'CVE-2022-2590',
    'CVE-2018-3615',
    'CVE-2022-0392',
    'CVE-2023-21492',
    'CVE-2022-1650',
    'CVE-2022-23824',
    'CVE-2022-36446',
    'CVE-2023-23375',
    'CVE-2022-37962',
    'CVE-2022-1853',
    'CVE-2021-1048',
    'CVE-2022-4415',
    'CVE-2022-21127',
    'CVE-2023-0216',
    'CVE-2023-29199',
    'CVE-2022-22587',
    'CVE-2023-0266',
    'CVE-2022-1161',
    'CVE-2022-29162',
    'CVE-2022-31199',
    'CVE-2023-24540',
    'CVE-2023-0045',
    'CVE-2023-24488',
    'CVE-2022-35804',
    'CVE-2023-30547',
    'CVE-2022-2296',
    'CVE-2022-0336',
    'CVE-2022-30137',
    'CVE-2022-21990',
    'CVE-2022-27405',
    'CVE-2022-3094',
    'CVE-2022-2175',
    'CVE-2022-28327',
    'CVE-2022-20857',
    'CVE-2022-0811',
    'CVE-2023-1999',
    'CVE-2022-22674',
    'CVE-2023-0217',
    'CVE-2022-35255',
    'CVE-2023-0210',
    'CVE-2022-39327',
    'CVE-2022-40735',
    'CVE-2022-37968',
    'CVE-2021-35247',
    'CVE-2022-1154',
    'CVE-2021-4083',
    'CVE-2019-11477',
    'CVE-2022-44267',
    'CVE-2022-40156',
    'CVE-2020-1048',
    'CVE-2020-25717',
    'CVE-2022-22973',
    'CVE-2022-27406',
    'CVE-2022-24675',
    'CVE-2020-1934',
    'CVE-2022-35256',
    'CVE-2022-1529',
    'CVE-2022-26373',
    'CVE-2022-2880',
    'CVE-2022-1786',
    'CVE-2022-26486',
    'CVE-2022-0005',
    'CVE-2021-3450',
    'CVE-2020-2555',
    'CVE-2002-0013',
    'CVE-2009-0901',
    'CVE-2016-6309',
    'CVE-2016-6367',
    'CVE-2017-0261',
    'CVE-2017-12629',
    'CVE-2017-15715',
    'CVE-2017-7657',
    'CVE-2018-10237',
    'CVE-2018-20250',
    'CVE-2018-25031',
    'CVE-2018-8611',
    'CVE-2019-0215',
    'CVE-2019-0220',
    'CVE-2019-10092',
    'CVE-2019-1181',
    'CVE-2019-17569',
    'CVE-2019-18276',
    'CVE-2019-5418',
    'CVE-2019-9641',
    'CVE-2020-0787',
    'CVE-2020-10770',
    'CVE-2020-11651',
    'CVE-2020-11899',
    'CVE-2020-16875',
    'CVE-2020-2021',
    'CVE-2020-27216',
    'CVE-2020-8625',
    'CVE-2021-1585',
    'CVE-2021-21300',
    'CVE-2021-2163',
    'CVE-2021-22060',
    'CVE-2021-23336',
    'CVE-2021-23841',
    'CVE-2021-28550',
    'CVE-2021-30116',
    'CVE-2021-30560',
    'CVE-2021-30632',
    'CVE-2021-3121',
    'CVE-2021-31535',
    'CVE-2021-33193',
    'CVE-2021-33813',
    'CVE-2021-35515',
    'CVE-2021-35550',
    'CVE-2021-37404',
    'CVE-2021-39226',
    'CVE-2021-4044',
    'CVE-2021-4160',
    'CVE-2021-44141',
    'CVE-2021-44223',
    'CVE-2021-44529',
    'CVE-2022-0235',
    'CVE-2022-20759',
    'CVE-2022-21248',
    'CVE-2022-22817',
    'CVE-2022-22942',
    'CVE-2022-23648',
    'CVE-2022-24735',
    'CVE-2022-24839',
    'CVE-2022-26318',
    'CVE-2022-26520',
    'CVE-2022-26845',
    'CVE-2022-27593',
    'CVE-2022-28693',
    'CVE-2022-31030',
    'CVE-2022-3180',
    'CVE-2022-3219',
    'CVE-2022-32205',
    'CVE-2022-34302',
    'CVE-2022-39399',
    'CVE-2022-44640',
    'CVE-2023-1829',
    'CVE-2023-22622',
    'CVE-2023-28709',
    'CVE-2018-0765',
    'CVE-2021-40474',
    'CVE-2022-21842',
    'CVE-2022-23176',
    'CVE-2014-1761',
    'CVE-2018-16844',
    'CVE-2021-21999',
    'CVE-2021-27365',
    'CVE-2020-8174',
    'CVE-2017-8620',
    'CVE-2021-43217',
    'CVE-2022-29500',
    'CVE-2015-2545',
    'CVE-2008-2992',
    'CVE-2018-1334',
    'CVE-2021-0316',
    'CVE-2021-22931',
    'CVE-2021-44757',
    'CVE-2022-22274',
    'CVE-2016-0167',
    'CVE-2020-4004',
    'CVE-2022-20676',
    'CVE-2020-0466',
    'CVE-2021-29923',
    'CVE-2021-42757',
    'CVE-2022-23772',
    'CVE-2010-1622',
    'CVE-2021-24084',
    'CVE-2022-24541',
    'CVE-2022-26919',
    'CVE-2021-3715',
    'CVE-2022-1015',
    'CVE-2020-10543',
    'CVE-2022-21920',
    'CVE-2018-12886',
    'CVE-2020-11993',
    'CVE-2022-0155',
    'CVE-2020-17527',
    'CVE-2021-27219',
    'CVE-2022-24921',
    'CVE-2021-3438',
    'CVE-2022-30138',
    'CVE-2021-37973',
    'CVE-2021-26708',
    'CVE-2021-3520',
    'CVE-2021-35567',
    'CVE-2022-0547',
    'CVE-2021-22041',
    'CVE-2020-24586',
    'CVE-2022-22594',
    'CVE-2019-1458',
    'CVE-2021-3752',
    'CVE-2021-28831',
    'CVE-2020-0465',
    'CVE-2020-17051',
    'CVE-2019-5482',
    'CVE-2016-3088',
    'CVE-2019-12418',
    'CVE-2022-24767',
    'CVE-2021-33742',
    'CVE-2021-30883',
    'CVE-2020-15368',
    'CVE-2022-22532',
    'CVE-2022-21974',
    'CVE-2021-36948',
    'CVE-2021-3653',
    'CVE-2021-32648',
    'CVE-2019-17563',
    'CVE-2022-28346',
    'CVE-2022-21846',
    'CVE-2022-0002',
    'CVE-2020-0543',
    'CVE-2022-0573',
    'CVE-2019-0230',
    'CVE-2017-14491',
    'CVE-2016-2124',
    'CVE-2021-26423',
    'CVE-2012-0507',
    'CVE-2019-15903',
    'CVE-2022-24775',
    'CVE-2022-20773',
    'CVE-2022-1343',
    'CVE-2022-0330',
    'CVE-2021-22042',
    'CVE-2022-23677',
    'CVE-2020-14803',
    'CVE-2022-1329',
    'CVE-2014-0226',
    'CVE-2021-3808',
    'CVE-2022-23121',
    'CVE-2022-20650',
    'CVE-2022-20695',
    'CVE-2021-3972',
    'CVE-2021-0127',
    'CVE-2020-8165',
    'CVE-2022-20685',
    'CVE-2021-4122',
    'CVE-2022-22786',
    'CVE-2021-3970',
    'CVE-2022-29799',
    'CVE-2021-25219',
    'CVE-2021-4155',
    'CVE-2022-3942',
    'CVE-2021-28310',
    'CVE-2022-1232',
    'CVE-2021-4191',
    'CVE-2022-24087',
    'CVE-2020-3952',
    'CVE-2006-1547',
    'CVE-2012-5958',
    'CVE-2018-20843',
    'CVE-2019-13720',
    'CVE-2020-13934',
    'CVE-2020-14781',
    'CVE-2020-1968',
    'CVE-2020-25681',
    'CVE-2020-25682',
    'CVE-2020-36385',
    'CVE-2020-4005',
    'CVE-2020-9546',
    'CVE-2021-2161',
    'CVE-2021-22947',
    'CVE-2021-2341',
    'CVE-2021-25215',
    'CVE-2021-28480',
    'CVE-2021-28799',
    'CVE-2021-30657',
    'CVE-2021-3347',
    'CVE-2021-33910',
    'CVE-2021-36160',
    'CVE-2021-3621',
    'CVE-2021-38000',
    'CVE-2021-4028',
    'CVE-2021-4102',
    'CVE-2021-44168',
    'CVE-2021-45417',
    'CVE-2022-0686',
    'CVE-2022-21306',
    'CVE-2022-21831',
    'CVE-2022-23134',
    'CVE-2022-23773',
    'CVE-2022-24769',
    'CVE-2022-24790',
    'CVE-2022-26133'
];

const mskb = [
    'KB5025221',
    'KB5025221',
    'KB4534310',
    'KB4534310',
    'KB5025229',
    'KB5025229',
    'KB5025228',
    'KB5025228',
    'KB5023696',
    'KB5023696',
    'KB5023702',
    'KB5023702',
    'KB5023697',
    'KB5023697',
    'KB5022303',
    'KB5022303',
    'KB5022834',
    'KB5022834',
    'KB5016623',
    'KB5016623',
    'KB5017328',
    'KB5017328',
    'KB5023788',
    'KB5023788',
    'KB5019980',
    'KB5019980',
    'KB5022845',
    'KB5022845',
    'KB5020023',
    'KB5020023',
    'KB5014738',
    'KB5014738',
    'KB5022842',
    'KB5022842',
    'KB5026363',
    'KB5026363',
    'KB5026362',
    'KB5026362',
    'KB5022728',
    'KB5022728',
    'KB5013952',
    'KB5013952',
    'KB5005565',
    'KB5005565',
    'KB5021095',
    'KB5021095',
    'KB5013624',
    'KB5013624',
    'KB5014026',
    'KB5014026',
    'KB5016058',
    'KB5016058',
    'KB5022838',
    'KB5022838',
    'KB5018418',
    'KB5018418',
    'KB5018427',
    'KB5018427',
    'KB5014353',
    'KB5014353',
    'KB5022289',
    'KB5022289',
    'KB5002254',
    'KB5002254',
    'KB5014746',
    'KB5014746',
    'KB5015874',
    'KB5015874',
    'KB5016622',
    'KB5016622',
    'KB5020679',
    'KB5020679',
    'KB4096236',
    'KB4096236',
    'KB5021124',
    'KB5021124',
    'KB5025285',
    'KB5025285',
    'KB5020010',
    'KB5020010',
    'KB5014553',
    'KB5014553',
    'KB5014355',
    'KB5014355',
    'KB5022503',
    'KB5022503',
    'KB5015371',
    'KB5015371',
    'KB5023790',
    'KB5023790',
    'KB5022497',
    'KB5022497',
    'KB5017501',
    'KB5017501',
    'KB5022729',
    'KB5022729',
    'KB5002112',
    'KB5002112',
    'KB5017377',
    'KB5017377',
    'KB5023038',
    'KB5023038',
    'KB5022731',
    'KB5022731',
    'KB5022782',
    'KB5022782',
    'KB5021129',
    'KB5021129',
    'KB5021126',
    'KB5021126',
    'KB5021125',
    'KB5021125',
    'KB5014356',
    'KB5014356',
    'KB5015322',
    'KB5015322',
    'KB5022894',
    'KB5022894',
    'KB5022346',
    'KB5022346',
    'KB5014164',
    'KB5014164',
    'KB5018476',
    'KB5018476',
    'KB5014025',
    'KB5014025',
    'KB5014011',
    'KB5014011',
    'KB5019964',
    'KB5019964',
    'KB5024296',
    'KB5024296',
    'KB5012596',
    'KB5012596',
    'KB5023705',
    'KB5023705',
    'KB5014351',
    'KB5014351',
    'KB5021093',
    'KB5021093',
    'KB5023706',
    'KB5023706',
    'KB3074550',
    'KB3074550',
    'KB5026415',
    'KB5026415',
    'KB5002288',
    'KB5002288',
    'KB5014365',
    'KB5014365',
    'KB5014165',
    'KB5014165',
    'KB5002121',
    'KB5002121',
    'KB5013625',
    'KB5013625',
    'KB5014354',
    'KB5014354',
    'KB5025288',
    'KB5025288',
    'KB5017305',
    'KB5017305',
    'KB5014001',
    'KB5014001',
    'KB5018922',
    'KB5018922',
    'KB5014261',
    'KB5014261',
    'KB5019959',
    'KB5019959',
    'KB5023698',
    'KB5023698',
    'KB3116180',
    'KB3116180',
    'KB5002026',
    'KB5002026',
    'KB5002323',
    'KB5002323',
    'KB5021127',
    'KB5021127',
    'KB5021128',
    'KB5021128',
    'KB5016618',
    'KB5016618',
    'KB5022143',
    'KB5022143',
    'KB5011570',
    'KB5011570',
    'KB4535102',
    'KB4535102',
    'KB5002051',
    'KB5002051',
    'KB5014692',
    'KB5013839',
    'KB5013942',
    'KB5018411',
    'KB3078662',
    'KB5021045',
    'KB5011495',
    'KB5022733',
    'KB5021037',
    'KB5005698',
    'KB5008277',
    'KB5012670',
    'KB5013872',
    'KB5026368',
    'KB5012331',
    'KB5018419',
    'KB5013943',
    'KB4536952',
    'KB4503292',
    'KB5002115',
    'KB3143081',
    'KB5021123',
    'KB5011503',
    'KB3005210',
    'KB4022619',
    'KB5002197',
    'KB2893294',
    'KB5009624',
    'KB5010342',
    'KB3183043',
    'KB5025915',
    'KB5002279',
    'KB5013868',
    'KB5002184',
    'KB5023288',
    'KB5010359',
    'KB5012639',
    'KB5002143',
    'KB4011574',
    'KB5005573',
    'KB5014702',
    'KB5018454',
    'KB5027536',
    'KB5003173',
    'KB4056894',
    'KB5022546',
    'KB5026366',
    'KB3114375',
    'KB5015321',
    'KB5002316',
    'KB5022338',
    'KB5002351',
    'KB5005030',
    'KB5022732',
    'KB5012117',
    'KB3074230',
    'KB4486670',
    'KB5009546',
    'KB3183431',
    'KB4586793',
    'KB3134220',
    'KB4504710',
    'KB4055532',
    'KB5002052',
    'KB5014329',
    'KB4336986',
    'KB5022730',
    'KB4493152',
    'KB5014748',
    'KB5013627',
    'KB5011564',
    'KB5002140',
    'KB5012698',
    'KB5002337',
    'KB5014747',
    'KB5021522',
    'KB5001402',
    'KB4601345',
    'KB5004947',
    'KB4567703',
    'KB5022735',
    'KB3213551',
    'KB4018073',
    'KB5022188',
    'KB5011486',
    'KB5016627',
    'KB4583462',
    'KB4025333',
    'KB5008207',
    'KB4025336',
    'KB5010324',
    'KB5004238',
    'KB4571719',
    'KB4601318',
    'KB4011185',
    'KB5020689',
    'KB5006669',
    'KB5001779',
    'KB5020694',
    'KB5010351',
    'KB5027540',
    'KB5016672',
    'KB5001330',
    'KB4525235',
    'KB5022785',
    'KB5016987',
    'KB5016676',
    'KB5002348',
    'KB5014742',
    'KB5007247',
    'KB5015424',
    'KB5016990',
    'KB5022727',
    'KB5022348',
    'KB4583456',
    'KB3192884',
    'KB5002198',
    'KB4052908',
    'KB4336919',
    'KB5012118',
    'KB3205408',
    'KB5004244',
    'KB5013628',
    'KB3172727',
    'KB5012328',
    'KB4583459',
    'KB5005613',
    'KB4504738',
    'KB5001342',
    'KB5015862',
    'KB4532098',
    'KB5000871',
    'KB5006714',
    'KB5003638',
    'KB4565349',
    'KB3178703',
    'KB5010395',
    'KB5005043',
    'KB4074592',
    'KB4592503',
    'KB5006672',
    'KB5002369',
    'KB5002175',
    'KB5012591',
    'KB3170460',
    'KB4512578',
    'KB4551853',
    'KB4493470',
    'KB3123479',
    'KB3115322',
    'KB4503276',
    'KB5012121',
    'KB5004294',
    'KB3104519',
    'KB4471984',
    'KB4480963',
    'KB5010419',
    'KB4513696',
    'KB5012647',
    'KB4019264',
    'KB5020686',
    'KB5022872',
    'KB5022903',
    'KB5002167',
    'KB5002187',
    'KB5014701',
    'KB4571480',
    'KB5025287',
    'KB5015429',
    'KB5002116',
    'KB5023756',
    'KB5002338',
    'KB5015875',
    'KB4506164',
    'KB5002124',
    'KB5011649',
    'KB5002204',
    'KB5002060',
    'KB4583463',
    'KB4011262',
    'KB4099635',
    'KB5002148',
    'KB5014741',
    'KB3162075',
    'KB4011628',
    'KB4339279',
    'KB3127945',
    'KB3105256',
    'KB5006729',
    'KB4535706',
    'KB5001403',
    'KB5013999',
    'KB4505219',
    'KB4092465',
    'KB5013944',
    'KB3203464',
    'KB5000822',
    'KB4019115',
    'KB5008263',
    'KB5004958',
    'KB3115464',
    'KB4549949',
    'KB4580346',
    'KB4565912',
    'KB5004951',
    'KB5003174',
    'KB4593226',
    'KB5012649',
    'KB5003197',
    'KB4056615',
    'KB5000803',
    'KB5004954',
    'KB5002177',
    'KB4537759',
    'KB4011580',
    'KB5005627',
    'KB5012326',
    'KB5001942',
    'KB3163244',
    'KB5002005',
    'KB5005076',
    'KB3174644',
    'KB4570333',
    'KB5014017',
    'KB4103715',
    'KB4022162',
    'KB4586830',
    'KB4057113',
    'KB4494440',
    'KB4577015',
    'KB4586805',
    'KB3204723',
    'KB5021079',
    'KB4534273',
    'KB4538461',
    'KB5012592',
    'KB4601319',
    'KB5005633',
    'KB4493160',
    'KB5009610',
    'KB4088787',
    'KB4103718',
    'KB4054518',
    'KB3134214',
    'KB5006749',
    'KB3178674',
    'KB5013630',
    'KB5005106',
    'KB5012650',
    'KB5009718',
    'KB5002033',
    'KB4601051',
    'KB5011552',
    'KB5002035',
    'KB5009586',
    'KB4550994',
    'KB5002056',
    'KB4571703',
    'KB5010404',
    'KB5002004',
    'KB5011485',
    'KB5004285',
    'KB4486726',
    'KB5005623',
    'KB5002137',
    'KB5007012',
    'KB5009721',
    'KB5008244',
    'KB5004953',
    'KB5001347',
    'KB5003671',
    'KB5004378',
    'KB4571723',
    'KB4537762',
    'KB4507460',
    'KB5012666',
    'KB5004298',
    'KB5008631',
    'KB4524157',
    'KB5005566',
    'KB5009545',
    'KB5004245',
    'KB5010345',
    'KB5009722',
    'KB4056898',
    'KB4565354',
    'KB5000808',
    'KB4601887',
    'KB5026413',
    'KB4556799',
    'KB4056897',
    'KB4013429'
];

const nessus = [
    'SMB_NT_MS23_APR_5025239.NASL',
    'SMB_NT_MS22_JUL_5015811.NASL',
    'WINDOWS_DCOM_HARDENING_REG_CHECK.NASL',
    'SMB_NT_MS22_JUL_5015814.NASL',
    'SMB_NT_MS22_JUN_5014697.NASL',
    'SMB_NT_MS22_DEC_5021233.NASL',
    'SMB_NT_MS22_NOV_5019966.NASL',
    'SMB_NT_MS22_MAY_5013941.NASL',
    'MS17_MAY_SMBV1.NASL',
    'SMB_NT_MS22_SEP_ENDPOINT_CONFIGURATION_MANAGER.NASL',
    'SMB_NT_MS17_JUL_4025339.NASL',
    'SMB_NT_MS22_JUL_5015877.NASL',
    'SMB_NT_MS22_APR_5012647.NASL',
    'SMB_NT_MS23_MAR_5023706.NASL',
    'SMB_NT_MS23_JAN_5022287.NASL',
    'SMB_NT_MS22_APR_5012599.NASL',
    'SMB_NT_MS22_OCT_5018410.NASL',
    'APACHE_2_4_41.NASL',
    'SMB_NT_MS23_MAR_5023764.NASL',
    'SMB_NT_MS23_JAN_5022291.NASL',
    'SMB_NT_MS22_MAY_5013945.NASL',
    'SMB_NT_MS22_AUG_EXCEL.NASL',
    'SMB_NT_MS23_FEB_5022836.NASL',
    'SMB_NT_MS21_DEC_5008212.NASL',
    'OPENSSH_74.NASL',
    'SMB_NT_MS21_DEC_5008218.NASL',
    'SMB_NT_MS22_MAR_5011487.NASL',
    'SMB_NT_MS16-065.NASL',
    'SMB_NT_MS16-019.NASL',
    'WEB_APPLICATION_SCANNING_98596',
    'NODEJS_2021_AUG.NASL',
    'SMB_KB2982792.NASL',
    'SMB_NT_MS20_OCT_FLASH.NASL',
    'SMB_NT_MS18_MAY_4103723.NASL',
    'SMB_NT_MS22_FEB_5010392.NASL',
    'SMB_NT_MS21_NOV_5007186.NASL',
    'QUICKTIME_767.NASL',
    'OPENSSH_44.NASL',
    'SMB_NT_MS17_JUN_4023307.NASL',
    'SMB_NT_MS22_JUL_5015807.NASL',
    'MACOSX_MS15-128.NASL',
    'WEB_APPLICATION_SCANNING_113079',
    'SMB_KB3103688.NASL',
    'SMB_NT_MS23_MAY_5026409.NASL',
    'SMB_NT_MS21_SEP_5005568.NASL',
    'SMB_NT_MS22_OCT_5018419.NASL',
    'SMB_SIGNING_DISABLED.NASL',
    'WEB_APPLICATION_SCANNING_112435',
    'SMB_NT_MS22_JUL_5015827.NASL',
    'SMB_KB3009008.NASL',
    'SMB_NT_MS22_JUN_5014678.NASL',
    'SMB_NT_MS16-127.NASL',
    'MSSQL_VERSION.NASL',
    'SMB_NT_MS21_JUN_5003637.NASL',
    'SHELLSHOCK_POSTFIX_FILTERS.NASL',
    'APACHE_2_4_7.NASL',
    'DRUPAL_CVE-2019-6340_RCE.NBIN',
    'WEB_APPLICATION_SCANNING_113254',
    'FIND_AP.NASL',
    'APACHE_LOG4J_1_X_MULTIPLE_VULNERABILITIES.NASL',
    'WEB_APPLICATION_SCANNING_113006',
    'CPE.NBIN',
    'ORACLELINUX_ELSA-2022-6913.NASL',
    'SMB_NT_MS22_JAN_5009595.NASL',
    'SMB_NT_MS22_OCT_VISUAL_STUDIO.NASL',
    'SMB_NT_MS21_NOV_5007192.NASL',
    'SMB_NT_MS20_AUG_4571694.NASL',
    'SMB_NT_MS21_JUN_5003646.NASL',
    'SMB_NT_MS21_JAN_4598243.NASL',
    'SMB_NT_MS22_JUL_OFFICE_C2R.NASL',
    'SMB_NT_MS21_NOV_5007206.NASL',
    'SMB_NT_MS23_JUN_5027282.NASL',
    'SMB_NT_MS22_JUN_5014699.NASL',
    'SMB_KB3050995.NASL',
    'MSRPC_DCOM.NASL',
    'WEBLOGIC_2015_4852.NASL',
    'APACHE_2_2_15.NASL',
    'UBIQUITI_UNIFI_NETWORK_LOG4SHELL.NBIN',
    'APACHE_2_4_52.NASL',
    'UNREAL_IRCD_BACKDOOR.NASL',
    'FCKEDITOR_CURRENTFOLDER_FILE_UPLOAD.NASL',
    'SMB_NT_MS09-063.NASL',
    'SMB_NT_MS12-027.NASL',
    'APACHE_2_4_23.NASL',
    'NGINX-2021-000300.NASL',
    'TCP_TIMESTAMPS.NASL',
    'WEB_APPLICATION_SCANNING_112698',
    'SMB_NT_MS21_JAN_4598230.NASL',
    'SMB_KB3119884.NASL',
    'SMB_NT_MS22_MAR_5011560.NASL',
    'SMB_NT_MS21_MAY_5003171.NASL',
    'SMB_NT_MS22_JUL_5015808.NASL',
    'SMB_NT_MS21_MAY_5003169.NASL',
    'FLASH_PLAYER_APSB15-25.NASL',
    'SMB_NT_MS20_JUN_FLASH.NASL',
    'SMB_NT_MS20_DEC_4592449.NASL',
    'SMB_NT_MS20_MAR_4551762.NASL',
    'SMB_NT_MS18_SEP_MICROCODE.NASL',
    'APACHE_2_4_25.NASL',
    'WEB_APPLICATION_SCANNING_113917',
    'PHP_5_4_16.NASL',
    'PHP_5_6_40.NASL',
    'AZUL_ZULU_20_30_12.NASL',
    'PHP_7_4_33.NASL',
    'PHP_5_3_29.NASL',
    'JQUERY-UI_1_13_2.NASL',
    'WEB_APPLICATION_SCANNING_112438',
    'NTP_MODE6_QUERY.NASL',
    'IIS_7_PCI.NASL',
    'ORACLE_JAVA_CPU_JAN_2023.NASL',
    'TENABLE_OT_SIEMENS_CVE-2019-12256.NASL',
    '8749.PRM',
    'SMB_NT_MS15-044.NASL',
    'SMB_NT_MS15-011.NASL',
    'SMB_NT_MS21_NOV_EXCEL.NASL',
    'SMB_NT_MS22_NOV_5020013.NASL',
    'SMB_KB3123040.NASL',
    'SMB_NT_MS21_NOV_5007255.NASL',
    'SMB_KB2269637.NASL',
    'SMB_NT_MS22_OCT_5018479.NASL',
    'SMB_NT_MS20_DEC_4586793.NASL',
    'SMB_NT_MS19_MAY_4499164.NASL',
    'SMB_NT_MS19_SEP_4516044.NASL',
    'SMB_NT_MS18_APR_4093119.NASL',
    'SMB_NT_MS21_DEC_5008285.NASL',
    'SMB_NT_MS21_NOV_5007189.NASL',
    'SMB_NT_MS20_MAR_4540670.NASL',
    'SMB_NT_MS20_OCT_4577668.NASL',
    'SMB_NT_MS22_JAN_5009621.NASL',
    'SMB_NT_MS20_AUG_DOTNET.NASL',
    'SMB_NT_MS22_JAN_OFFICE_SHAREPOINT_2013.NASL',
    'SMB_NT_MS20_MAY_4556813.NASL',
    'SMB_NT_MS21_OCT_INTERNET_EXPLORER.NASL',
    'SMB_NT_MS21_MAR_OFFICE.NASL',
    'SMB_NT_MS16-142.NASL',
    'SMB_NT_MS21_OCT_5006674.NASL',
    'SMB_NT_MS21_JAN_MSSQL.NASL',
    'SMB_NT_MS18_AUG_MSSQL.NASL',
    'SMB_NT_MS18_NOV_4477029.NASL',
    'SMB_KB_2286198.NASL',
    'FILEZILLA_SERVER_0944.NASL',
    'APACHE_2_2_16.NASL',
    'TOMCAT_5_5_35.NASL',
    'TOMCAT_7_0_94.NASL',
    'TOMCAT_5_5_23.NASL',
    'TOMCAT_7_0_88.NASL',
    'LITESPEED_POISON_NULL_BYTE.NASL',
    'JQUERY_FILEUPLOAD_RCE.NASL',
    'ICECAP_DEFAULT_PW.NASL',
    'APACHE_2_4_51.NASL',
    'FEDORA_2007-2145.NASL',
    'APACHE_2_4_53.NASL',
    'OPENSSH_33.NASL',
    'APACHE_2_4_46.NASL',
    'NGINX_1_17_3.NASL',
    'PHP_7_4_11.NASL',
    'SMB_NT_MS23_JAN_MSRT.NASL',
    'IPMI_PASSHASH_DISCLOSURE.NASL',
    'SSL_CRIME.NASL',
    'APACHE_LOG4J_1_2.NASL',
    'TOMCAT_SERVER_DEFAULT_FILES.NASL',
    'MACOSX_MS15-080.NASL',
    'OPENSSL_1_0_2K.NASL',
    'HP_ONEVIEW_1_10.NASL',
    '700213.PRM',
    'SAMBA_BADLOCK.NASL',
    'PHP_7_3_33.NASL',
    'WEB_APPLICATION_SCANNING_113673',
    'SPLUNK_824.NASL',
    'UBUNTU_USN-5233-2.NASL',
    'FILEZILLA_373.NASL',
    'TOMCAT_9_0_65.NASL',
    'SMB_KB2719615.NASL',
    '1344.PRM',
    'F5_BIGIP_SOL11742512.NASL',
    'SMB_NT_MS09-050.NASL',
    'MDNS.NASL',
    'SMB_NT_MS21_JUL_5004946.NASL',
    'SMB_NT_MS19_SEP_FLASH.NASL',
    'SMB_NT_MS21_FEB_4601347.NASL',
    'SMB_NT_MS21_JUN_5003681.NASL',
    'SMB_NT_MS21_FEB_4601384.NASL',
    'SMB_NT_MS22_JAN_5009619.NASL',
    'SMB_NT_MS21_DEC_EXCEL.NASL',
    'SMB_NT_MS22_MAR_5011552.NASL',
    'SMB_NT_MS21_MAR_EXCHANGE_2010_OOB.NASL',
    'MACOSX_MS17_JUNE_OFFICE.NASL',
    'MACOS_MS22_JAN_OFFICE.NASL',
    'SMB_NT_MS12-063.NASL',
    'SMB_NT_MS21_OCT_5006667.NASL',
    'SMB_NT_MS21_APR_5001337.NASL',
    'SMB_NT_MS21_JUN_5003635.NASL',
    'ALA_ALAS-2018-939.NASL',
    'SMB_NT_MS20_NOV_4586845.NASL',
    'SMB_NT_MS17_JUN_4022715_CVE-2017-8529.NASL',
    'APACHE_ZOOKEEPER_3_5_5.NASL',
    'APACHE_LOG4J_2_16_0.NASL'
];

const msupdate = [
    'MS:909091D1-7771-48C0-9BB4-32BE8EE93433',
    'MS:04678195-DA57-4416-824D-4357D2F2515B',
    'MS:4F5807EB-4C38-425A-B3C4-6A1AE6ACEABB',
    'MS:F301F4A6-71BE-4071-BEA6-D847820BDB65',
    'MS:F5AEE567-7884-4C28-9B48-9B76CE9834DB',
    'MS:A46A1185-7B6E-4CB5-9126-1D8191037F59',
    'MS:9489D8C1-9A07-471F-8D76-62A841C3A22E',
    'MS:D973C80C-8187-4583-BD59-3CAE8826E0E1',
    'MS:18FF2614-485B-4C57-A2F6-4D3EF19B51A4',
    'MS:F6626BA5-E616-44CC-877B-366626FBF882',
    'MS:2A851E6F-B061-4E1A-923B-6F8A6A0E9B53',
    'MS:B08FD453-5B2A-47D9-A581-ACD7E46B29B1',
    'MS:39D86537-06F8-4CA2-BCA0-98FCBFCCDF73',
    'MS:0616AB23-14CE-4732-858D-684FE12AA775',
    'MS:5095222E-C295-42DF-828B-89A861209EB2',
    'MS:36AF0906-558D-4705-BD7E-24CF412D9E51',
    'MS:CC10956C-05F3-4CD6-B732-A85542A5CCC7',
    'MS:BD23D7A2-AEFB-47D2-BDC1-D9FC3A92E340',
    'MS:BAA53198-3C0A-48D1-815F-754CCD365D46',
    'MS:4361108D-D09B-4C4D-8B2F-F1167F7B8C57',
    'MS:CEFB2105-7FCC-4591-B975-8FBCB0BA8244',
    'MS:3BD7F9F1-FB34-4468-B761-D4B5CE14DA40',
    'MS:7E45A176-F960-46CF-8A7B-0B47470298A8',
    'MS:0E0B56E0-571B-43C4-9593-6F551CF42B79',
    'MS:5ACC8497-3291-459B-8C80-5B9718AD65C3',
    'MS:1CCBF8D2-E571-44A9-BBFE-B9BEF824CD4A',
    'MS:F694802E-9115-4340-AB20-6194B1E2560D',
    'MS:8A6CF442-7478-4735-9D68-BC93326A08A5',
    'MS:E3FB4314-3BE6-45A7-A51A-48B83D0062AD',
    'MS:9F1C1FB9-5C5D-49A1-95E4-6C7D05272404',
    'MS:CAEE175D-AB0F-4D97-A011-027AD4C0021C',
    'MS:15A51B22-A428-4A1B-A2B4-AE1F0EA7C622',
    'MS:B1F5CDB6-0F6C-4AC1-A985-4206A1DAF5C7',
    'MS:BFAC19AB-2D9C-4346-8349-933C98A9397D',
    'MS:D17800FF-C077-4D51-93F8-193818E7962D',
    'MS:8246DBD0-7B3C-4C8E-8397-75CC1EF711C4',
    'MS:99BC9A0F-F8A2-4580-8824-EACFD61F3954',
    'MS:2A697996-9BBD-469E-A29F-982F23723025',
    'MS:C7ADCF3D-7417-448A-886E-7F2C81401D62',
    'MS:69CB977D-3554-4899-BC97-5663BCC5776E',
    'MS:10826611-9865-402E-90CB-DA7E9B018C59',
    'MS:07BBCA14-2268-4BF3-8143-AC6E00E4E5D1',
    'MS:3E5937B5-92F9-4600-B3FF-0F25643D5FB0',
    'MS:04B277E8-3478-4FAA-ABD0-062036CF7371',
    'MS:A1CDD43D-2282-4360-9C8C-D37937647F7B',
    'MS:D84D1D26-4356-4055-B097-4A0667C390B2',
    'MS:1908A7C1-A9A8-4106-9850-04F592A62747',
    'MS:D68E0CB2-9501-405E-AF9C-156F352D6735',
    'MS:2F32B085-6BE1-4C20-A4B1-539498B7F90F',
    'MS:746E73B8-37FD-4519-8757-49660F46DF6F',
    'MS:4BE6AB03-0038-4323-9160-C309F530C673',
    'MS:ACFC2070-235D-4575-B050-0AE2D8C8239E',
    'MS:85583B49-E99A-4923-920C-42D5F74E1571',
    'MS:0FA166A3-3D8F-4880-8E41-9EB1E5473D87',
    'MS:DD351178-A282-4A5E-9F93-594EE703F206',
    'MS:D40C5191-CC81-44C2-8A55-9DD68F59CB04',
    'MS:D5D280BE-2496-4978-B82B-E53171FCAB17',
    'MS:58EA3411-0E36-4516-8C80-9AC5D54FD0F4',
    'MS:9CD3D6A0-2474-4577-B7A7-D1BA5234C128',
    'MS:C091B865-E45D-4B44-9FB2-9176620A442E',
    'MS:454BEBBC-D20D-4AC1-953E-52D57054D474',
    'MS:A97105E3-24C7-46F1-8AAA-7798332A1657',
    'MS:6964CF08-89CF-4A95-ACE6-FDB7A423C09C',
    'MS:D11FA70B-0F55-465C-8D11-EACB9B90AB8E',
    'MS:9E7512BD-B184-43DC-9BAC-064236FCD2CC',
    'MS:2C9CED09-FCB6-4057-92A7-6C742EE4236A',
    'MS:DBD186C7-8F9E-495F-978C-38895D4FEB9E',
    'MS:8B4F5ABB-5949-464E-A2A0-CD89A1B5EDFD',
    'MS:2EBAF040-C03D-40FD-9EDC-4A76308669F8',
    'MS:BA8A7290-7CA4-47B6-B016-830A33B4DF9D',
    'MS:F97A75AD-B1F6-4B06-B6C8-0C6EFF8286B1',
    'MS:D0E3526E-B4A4-45E7-A78A-8710781358CE',
    'MS:1EDB4837-6ED9-4F05-93EF-258636F72CCE',
    'MS:A4BA1701-45A7-4CB5-B434-FE8EB8DD278C',
    'MS:823BB4AD-E417-4384-AF82-1CCFD899D50B',
    'MS:32CACAA7-79A7-4F37-A186-1B0707C0FAFF',
    'MS:78C70D3D-B761-4B45-A8C2-3CB110BBD6E5',
    'MS:ADDDCE29-7ED2-4DD8-A8C5-023BA9BC621D',
    'MS:55A3F5E0-8E9E-4C96-9E74-C4869CCCF8C2',
    'MS:673709C6-E1ED-40D1-A806-93C585C8B035',
    'MS:E7703C2B-2148-4487-AEE7-8766AFEFBB83',
    'MS:C89FF789-6C35-4290-98F2-279083AF202E'
];

const openvas = [
    'OPENVAS:1361412562310143920',
    'OPENVAS:1361412562310108045',
    'OPENVAS:1361412562310806647',
    'OPENVAS:902846',
    'OPENVAS:1361412562310811820',
    'OPENVAS:1361412562310810815',
    'OPENVAS:1361412562310106471',
    'OPENVAS:1361412562310807856',
    'OPENVAS:1361412562310812238',
    'OPENVAS:1361412562310809708',
    'OPENVAS:1361412562310803805',
    'OPENVAS:1361412562310902955',
    'OPENVAS:1361412562310140433',
    'OPENVAS:1361412562310813141',
    'OPENVAS:1361412562310811922',
    'OPENVAS:1361412562310805092',
    'OPENVAS:1361412562310806013',
    'OPENVAS:1361412562310801494',
    'OPENVAS:1361412562310103440',
    'OPENVAS:902226',
    'OPENVAS:1361412562310810696',
    'OPENVAS:1361412562310807600',
    'OPENVAS:1361412562310811760',
    'OPENVAS:1361412562310808249',
    'OPENVAS:1361412562310815742',
    'OPENVAS:1361412562310812724',
    'OPENVAS:1361412562310806188',
    'OPENVAS:1361412562310814015',
    'OPENVAS:1361412562310805060',
    'OPENVAS:10816',
    'OPENVAS:1361412562310112134',
    'OPENVAS:1361412562310802087',
    'OPENVAS:1361412562310141636',
    'OPENVAS:1361412562310103825',
    'OPENVAS:1361412562310103923',
    'OPENVAS:1361412562310811262',
    'OPENVAS:1361412562310813137',
    'OPENVAS:1361412562310806705',
    'OPENVAS:1361412562310817142',
    'OPENVAS:1361412562310817226',
    'OPENVAS:1361412562310814894',
    'OPENVAS:1361412562310143545',
    'OPENVAS:1361412562310806049',
    'OPENVAS:1361412562310815831',
    'OPENVAS:1361412562310809892',
    'OPENVAS:1361412562310103185',
    'OPENVAS:1361412562310806963',
    'OPENVAS:1361412562310143812',
    'OPENVAS:1361412562310143347',
    'OPENVAS:1361412562310143319',
    'OPENVAS:1361412562310810946',
    'OPENVAS:1361412562310811202',
    'OPENVAS:1361412562310813645',
    'OPENVAS:1361412562310811055'
];

const zdt = [
    '1337DAY-ID-32009',
    '1337DAY-ID-32135',
    '1337DAY-ID-30601',
    '1337DAY-ID-30200',
    '1337DAY-ID-35307',
    '1337DAY-ID-22413',
    '1337DAY-ID-32964',
    '1337DAY-ID-34105',
    '1337DAY-ID-22713',
    '1337DAY-ID-24066',
    '1337DAY-ID-4527',
    '1337DAY-ID-30787',
    '1337DAY-ID-37431',
    '1337DAY-ID-24758',
    '1337DAY-ID-25440',
    '1337DAY-ID-35511',
    '1337DAY-ID-37354',
    '1337DAY-ID-37777',
    '1337DAY-ID-24739',
    '1337DAY-ID-27802',
    '1337DAY-ID-24201',
    '1337DAY-ID-36448',
    '1337DAY-ID-29938',
    '1337DAY-ID-27836',
    '1337DAY-ID-37881',
    '1337DAY-ID-34946',
    '1337DAY-ID-30190',
    '1337DAY-ID-18956',
    '1337DAY-ID-30003',
    '1337DAY-ID-29632',
    '1337DAY-ID-33546',
    '1337DAY-ID-29702',
    '1337DAY-ID-20597',
    '1337DAY-ID-33895',
    '1337DAY-ID-27809',
    '1337DAY-ID-33313',
    '1337DAY-ID-30386',
    '1337DAY-ID-37713',
    '1337DAY-ID-16022',
    '1337DAY-ID-38792',
    '1337DAY-ID-32476',
    '1337DAY-ID-32647',
    '1337DAY-ID-34352',
    '1337DAY-ID-37837',
    '1337DAY-ID-38259'
];

const exploitdb = [
    'EDB-ID:42941',
    'EDB-ID:50383',
    'EDB-ID:50406',
    'EDB-ID:40345',
    'EDB-ID:11515',
    'EDB-ID:50998',
    'EDB-ID:49489',
    'EDB-ID:50828',
    'EDB-ID:50057',
    'EDB-ID:48537',
    'EDB-ID:50532',
    'EDB-ID:45265',
    'EDB-ID:40679',
    'EDB-ID:47128',
    'EDB-ID:50559',
    'EDB-ID:46182',
    'EDB-ID:27944',
    'EDB-ID:49487',
    'EDB-ID:47553',
    'EDB-ID:16320',
    'EDB-ID:49960',
    'EDB-ID:5690',
    'EDB-ID:51032',
    'EDB-ID:49766',
    'EDB-ID:50180',
    'EDB-ID:50438',
    'EDB-ID:50883',
    'EDB-ID:51193',
    'EDB-ID:43450'
];

const mscve = [
    'MS:CVE-2022-37967',
    'MS:CVE-2022-34713',
    'MS:CVE-2022-35831',
    'MS:CVE-2022-41064',
    'MS:CVE-2022-41074',
    'MS:CVE-2022-41104',
    'MS:CVE-2017-0160',
    'MS:ADV190023',
    'MS:CVE-2022-30209',
    'MS:CVE-2022-34733',
    'MS:CVE-2016-7255',
    'MS:ADV230003',
    'MS:CVE-2022-37969',
    'MS:CVE-2022-37962',
    'MS:CVE-2023-21716',
    'MS:CVE-2022-44695',
    'MS:CVE-2022-23287',
    'MS:ADV220003',
    'MS:CVE-2023-28295',
    'MS:CVE-2018-1030',
    'MS:CVE-2021-38646',
    'MS:CVE-2022-37992',
    'MS:CVE-2022-26925',
    'MS:CVE-2019-0604',
    'MS:CVE-2021-41368',
    'MS:CVE-2021-31196',
    'MS:CVE-2021-36947',
    'MS:CVE-2021-40444'
];

const packetstorm = [
    'PACKETSTORM:162145',
    'PACKETSTORM:161293',
    'PACKETSTORM:162777',
    'PACKETSTORM:172713',
    'PACKETSTORM:171644',
    'PACKETSTORM:159216',
    'PACKETSTORM:161183',
    'PACKETSTORM:138233',
    'PACKETSTORM:128572',
    'PACKETSTORM:168003',
    'PACKETSTORM:152075',
    'PACKETSTORM:83077',
    'PACKETSTORM:166410',
    'PACKETSTORM:142266',
    'PACKETSTORM:173388',
    'PACKETSTORM:142211',
    'PACKETSTORM:141912'
];

const ubuntu = [
    'USN-4762-1',
    'USN-5223-2',
    'USN-5811-1',
    'USN-5440-1',
    'USN-5261-1',
    'USN-5559-1',
    'USN-6114-1',
    'USN-4773-1',
    'USN-3352-1',
    'USN-4378-1',
    'USN-3078-1',
    'USN-4639-1',
    'USN-5388-1',
    'USN-5509-1',
    'USN-1897-1',
    'USN-5342-2',
    'USN-5408-1'
];

const github = [
    'GHSA-C4R9-R8FH-9VJ2',
    'GHSA-GXR4-XJJ5-5PX2',
    'GHSA-36P3-WJMG-H94X',
    'GHSA-G5W6-MRJ7-75H2',
    'GHSA-GP69-XCM6-FFQJ',
    'GHSA-PFXF-WH96-FVJC',
    'GHSA-W354-2F3C-QVG9',
    'GHSA-XVCH-5GV4-984H',
    'GHSA-9C47-M6QQ-7P4H',
    'GHSA-G644-9GFX-Q4Q4',
    'GHSA-FHG7-M89Q-25R3',
    'GHSA-WW39-953V-WCQ6',
    'GHSA-92XJ-MQP7-VMCJ',
    'GHSA-6RH6-X8WW-9H97',
    'GHSA-W3QR-8V4R-592M',
    'GHSA-4PC3-96MX-WWC8'
];

const githubexploit = [
    '38A6D118-ABAB-59DD-9EA2-5FD83636A6BE',
    'C9CE76D2-C53D-50CF-BBF9-A8C9FC0B8BF8',
    '22E77377-F945-511A-8E98-34D6AF3EB68F',
    '4D682C42-8130-584B-A4DB-5E2FEEC3B23A',
    '423F06A3-70C4-58A1-8A3E-74C89561449D',
    'DF707FE2-EC27-5541-BC6A-6C7A0E9CC454',
    '8F5EF387-39FE-572B-850A-DE81CD5C1A23',
    '81A94AF3-F3C2-5DAE-9C64-154CF9502B01',
    'B118533B-1FEE-55C7-BE55-3391CA0BAA1B',
    '9E6B39D2-4F46-5C9D-81B9-32A2C96CBAD8',
    '1E11762E-7475-5A41-813C-F4C2B8595BB2',
    '92BAB396-41EA-57CF-81E2-43CFD97ABFF4',
    '2B8C7714-D2D7-50C4-BEB8-B616BD51A554',
    '57A481B6-594E-5AFE-869B-606BECC0CF16',
    'EA3A392A-81D4-57A6-8FAF-3249BD0E7D5D'
];

const osv = [
    'OSV:GHSA-GXR4-XJJ5-5PX2',
    'OSV:GHSA-86R3-4GQ8-XW8Q',
    'OSV:GHSA-HH26-6XWR-GGV7',
    'OSV:GHSA-4P24-VMCR-4GQJ',
    'OSV:GHSA-HHQ3-FF78-JV3G',
    'OSV:GHSA-76P3-8JX3-JPFQ',
    'OSV:GHSA-H2FP-XGX6-XH6F',
    'OSV:GHSA-F8Q6-P94X-37V3',
    'OSV:GHSA-QP49-3PVW-X4M5',
    'OSV:GHSA-2PQJ-H3VJ-PQGW',
    'OSV:GHSA-X949-7CM6-FM6P',
    'OSV:GHSA-PP75-XFPW-37G9',
    'OSV:GHSA-R7C9-C69M-RPH8',
    'OSV:GHSA-W77P-8CFG-2X43',
    'OSV:GHSA-V57X-GXFJ-484Q'
];

const securityvulns = [
    'SECURITYVULNS:VULN:11635',
    'SECURITYVULNS:DOC:20161',
    'SECURITYVULNS:DOC:3663',
    'SECURITYVULNS:VULN:14627',
    'SECURITYVULNS:DOC:9423',
    'SECURITYVULNS:DOC:32625',
    'SECURITYVULNS:VULN:13981',
    'SECURITYVULNS:VULN:13606',
    'SECURITYVULNS:DOC:4077',
    'SECURITYVULNS:DOC:23680',
    'SECURITYVULNS:DOC:10585',
    'SECURITYVULNS:VULN:13233'
];

const f5 = [
    'F5:K50455702',
    'F5:K48127735',
    'F5:K44611310',
    'F5:K08125515',
    'F5:K16828',
    'F5:K15780',
    'F5:K41133903',
    'F5:K52559937',
    'F5:K44454157',
    'F5:K61529042'
];

const hackerone = [
    'H1:1147449',
    'H1:520903',
    'H1:791893',
    'H1:66929',
    'H1:1888723',
    'H1:913695',
    'H1:291531',
    'H1:838196',
    'H1:1450014'
];

const ibm = [
    '0C6D510B96C1921840EB548081CBEE07051F107440F8CDE29CC80CC2DBA0285D',
    'CF5C01D1EF9FDB7F59A180E6BEECBE60BDE0AD16E9EA6F2DE05F405BE407D7B4',
    '90AC6404BEC26EE04C5116EFE61EADA448F6BE4B15643F95B0E2C306615BA410',
    'B8DAC33D69A4D5B5BD3B7843A77F0114EBE5CE2EA06FAF06667A4FC43658D093',
    'A8AFB71992370CD8AF9340FB766CB133288126FDA64D60A67D3B25CD154F2C52',
    '4AC135B103268AF4505A6F6E4633707C82E178B1CA4447D730F3CAC6F171B7F0',
    '28BEB526A175FA5B3502255FBDC5BF7BB126B6ED27BDA54C6121A22E8CE59FEB',
    '992D472A3766649B3AF435532AD5F4E49BABFB85B74B8C7C5D555A679DA52E94',
    'C1E30916BE02359F6F7A3AA9633FF8076AC11A0F2AF3CAA660C0F225D26CEBC4',
    '69B0080CDAAF3E64DF777920C686942F7C2B011032847BE36AFC463FC75D7FDE'
];

const threatpost = [
    'THREATPOST:FFC3DB875D4337781CF78C0D4B39F0E0',
    'THREATPOST:38BE049C6C451ED1B9E3037B2EA65D9A',
    'THREATPOST:FEAE151B1861BE9EF40E606D5434AE00',
    'THREATPOST:8F6E27B46891F0167D7799A73F1A9380',
    'THREATPOST:F45A1AEACEC0BF32FC6CDCECDF2B458D',
    'THREATPOST:8D6D4C10987CBF3434080EFF240D2E74',
    'THREATPOST:1586A7AFAD80F6833B8727AD8E03DB79',
    'THREATPOST:38E8D69F26ADB15A989532924B2A98C4'
];

const myhack58 = [
    'MYHACK58:62201785879',
    'MYHACK58:62201337758',
    'MYHACK58:62201681089',
    'MYHACK58:62201784747',
    'MYHACK58:62201786246',
    'MYHACK58:62200922541',
    'MYHACK58:62201561379',
    'VERACODE:36295',
    'VERACODE:30738',
    'VERACODE:33645',
    'VERACODE:42606',
    'VERACODE:41137',
    'VERACODE:42146'
];

const thn = [
    'THN:A24E3ECC17FDA35932981ED1D0B9B351',
    'THN:B0F0C0035DAAFA1EC62F15464A80677E',
    'THN:8B09CA26F6F5DC7194B3510040A54206',
    'THN:C63C0A0DDAE99C5A323D904265DB54BE',
    'THN:EDC4E93542AFAF751E67BF527C826DA4',
    'THN:0609724C4719D98B329E3CFBBAC9C4EB',
    'THN:40CDBC6B017F89BD673FA2F8C3CA1B06',
    'THN:9CE630030E0F3E3041E633E498244C8D',
    'THN:B8C45A3F30B93AE1B41277CEDFF4E5F7',
    'THN:48C46A645A455217EADCA99ECBFB18B8',
    'THN:FF56343C15BACA1C1CE83A105EFD7F77',
    'THN:A5E2056B783A702B2A37C7ECD02B811F',
    'THN:15F5633BC0BA0C82579744CCACA99558',
    'THN:25333BE60F6A8B077F64DCF8F915317C'
];

const kitploit = [
    'KITPLOIT:1907207623071471216',
    'KITPLOIT:1524013824799763480',
    'KITPLOIT:2960944162971904221',
    'KITPLOIT:564338237249156774',
    'KITPLOIT:5104415481503400470'
];

const cert = ['VU:405600', 'VU:101048', 'VU:421280', 'VU:120541', 'VU:794340'];

const saint = [
    'SAINT:BD676E3751A4D110EAA275BF92CA7E46',
    'SAINT:C50A339EFD5B2F96051BC00F96014CAA',
    'SAINT:DAEC4BA69103823E03C8F3C832C5B41D',
    'SAINT:D79A7CB8B12034409DA174D1F0EC34F3',
    'SAINT:96BA73BBA4A47CF34AB517314EA8D6A9'
];

const cisa = [
    'CISA:99DAB57F9B8063F8619B1A418B014DF1',
    'CISA:D70586B2C2D5D982D54DA686CCF0F4D1',
    'CISA:CE531246BF5FC97924EF93C811BBA0FF',
    'CISA:D39D876E64786DC5F13FB718A4507342'
];
const symantec = ['SMNTC-82657', 'SMNTC-100728', 'SMNTC-75745', 'SMNTC-106405'];
const seebug = ['SSV:72048', 'SSV:93099', 'SSV:96326', 'SSV:90853'];
const attackerkb = [
    'AKB:56338DBB-1286-429B-B980-5AEDD3A6E87C',
    'AKB:445F1CAC-C379-466A-AB3A-36C33D2AA1F5',
    'AKB:1DE0ADEC-8107-491A-BC8F-DCC3BF6EB3AB'
];
const kaspersky = ['KLA10785', 'KLA10470', 'KLA10616'];
const qualysblog = [
    'QUALYSBLOG:65C282BB0F312A3AD8A043024FD3D866',
    'QUALYSBLOG:CAF5B766E6B0E6C1A5ADF56D442E7BB2',
    'QUALYSBLOG:66E92B63FC165BEAF707A9D6B2807033'
];
const zeroscience = ['ZSL-2016-5300', 'ZSL-2013-5154', 'ZSL-2016-5359'];
const metasploit = [
    'MSF:EXPLOIT-WINDOWS-BROWSER-MS12_037_SAME_ID-',
    'MSF:AUXILIARY-ADMIN-DCERPC-CVE_2022_26923_CERTIFRIED-',
    'MSF:AUXILIARY-ADMIN-HTTP-NETGEAR_SOAP_PASSWORD_EXTRACTOR-'
];
const mageia = ['MGASA-2020-0182', 'MGASA-2016-0065', 'MGASA-2020-0231'];
const wpvulndb = ['WPVDB-ID:CBBE6C17-B24E-4BE4-8937-C78472A138B5', 'WPVDB-ID:982B1FE4-12DE-41F1-9A26-7BF1FC2C8BB6'];
const freebsd = ['0C6B008D-35C4-11E6-8E82-002590263BF5', 'CC42DB1C-C65F-11EC-AD96-0800270512F4'];
const altlinux = ['67A13AC63768BBDF42718B445D7E9578', '6DBE8E367D46EBEA3F9FD5CF0303A57B'];
const veeam = ['VEEAM:KB1849', 'VEEAM:KB4204'];
const nmap = ['NMAP:RDP-VULN-MS12-020.NSE', 'NMAP:REALVNC-AUTH-BYPASS.NSE'];
const prion = ['PRION:CVE-2023-2701', 'PRION:CVE-2022-31888'];
const cisco = ['CISCO-SA-20100217-ASA', 'CISCO-SA-20040420-TCP-NONIOS'];
const zdi = ['ZDI-15-517', 'ZDI-22-1690'];
const rapid7blog = ['RAPID7BLOG:03B1EB65D8A7CFE486943E2472225BA1', 'RAPID7BLOG:207700353EDB2453B1928E90A6683A0E'];
const hivepro = ['HIVEPRO:884DC2D35F8477A209AAB7B9045E6BAB', 'HIVEPRO:205916945365E4C9EB9829951A82295A'];
const redhatcve = ['RH:CVE-2021-27853', 'RH:CVE-2021-44228'];
const fireeye = ['FIREEYE:7D8237F41EA87865A58B16DF63389DAA'];
const malwarebytes = ['MALWAREBYTES:D133F234942A88D695B4882950A22971'];
const huntr = ['38A4B8E4-8C6E-4312-8302-13FD76F2AEC2'];
const cloudlinux = ['CLSA-2022:1657561632'];
const atlassian = ['BSERV-11753'];
const amazon = ['ALAS2-2022-1772'];
const ubuntucve = ['UB:CVE-2022-26929'];
const wordfence = ['WORDFENCE:107445D672F037011ADA9A0DA9FB8292'];
const patchstack = ['PATCHSTACK:9B7221BF243BC3C05A382848166AF232'];
const cnvd = ['CNVD-2022-40233'];
const ciscothreats = ['CISCO-THREAT-36769'];
const openbugbounty = ['OBB:3436763'];
const vulnerlab = ['VULNERABLE:665'];
const pentestpartners = ['PENTESTPARTNERS:1C6EAE3D0C10C1B56BD63325DEB012A1'];
const vmware = ['VMSA-2021-0028.8'];

const bulletins = [
    {
        type: 'cve',
        bulletins: CVE,
        family: 'NVD'
    },
    {
        type: 'mskb',
        bulletins: mskb,
        family: 'microsoft'
    },
    {
        type: 'nessus',
        bulletins: nessus,
        family: 'scanner'
    },
    {
        type: 'msupdate',
        bulletins: msupdate,
        family: 'microsoft'
    },
    {
        type: 'openvas',
        bulletins: openvas,
        family: 'scanner'
    },
    {
        type: 'zdt',
        bulletins: zdt,
        family: 'exploit'
    },
    {
        type: 'exploitdb',
        bulletins: exploitdb,
        family: 'exploit'
    },
    {
        type: 'mscve',
        bulletins: mscve,
        family: 'microsoft'
    },
    {
        type: 'packetstorm',
        bulletins: packetstorm,
        family: 'exploit'
    },
    {
        type: 'ubuntu',
        bulletins: ubuntu,
        family: 'unix'
    },
    {
        type: 'github',
        bulletins: github,
        family: 'software'
    },
    {
        type: 'githubexploit',
        bulletins: githubexploit,
        family: 'exploit'
    },
    {
        type: 'osv',
        bulletins: osv,
        family: 'software'
    },
    {
        type: 'securityvulns',
        bulletins: securityvulns,
        family: 'info'
    },
    {
        type: 'f5',
        bulletins: f5,
        family: 'software'
    },
    {
        type: 'hackerone',
        bulletins: hackerone,
        family: 'bugbounty'
    },
    {
        type: 'ibm',
        bulletins: ibm,
        family: 'software'
    },
    {
        type: 'threatpost',
        bulletins: threatpost,
        family: 'info'
    },
    {
        type: 'myhack58',
        bulletins: myhack58,
        family: 'info'
    },
    {
        type: 'thn',
        bulletins: thn,
        family: 'info'
    },
    {
        type: 'kitploit',
        bulletins: kitploit,
        family: 'tools'
    },
    {
        type: 'cert',
        bulletins: cert,
        family: 'info'
    },
    {
        type: 'saint',
        bulletins: saint,
        family: 'exploit'
    },
    {
        type: 'cisa',
        bulletins: cisa,
        family: 'info'
    },
    {
        type: 'symantec',
        bulletins: symantec,
        family: 'software'
    },
    {
        type: 'seebug',
        bulletins: seebug,
        family: 'exploit'
    },
    {
        type: 'attackerkb',
        bulletins: attackerkb,
        family: 'info'
    },
    {
        type: 'kaspersky',
        bulletins: kaspersky,
        family: 'info'
    },
    {
        type: 'qualysblog',
        bulletins: qualysblog,
        family: 'blog'
    },
    {
        type: 'zeroscience',
        bulletins: zeroscience,
        family: 'exploit'
    },
    {
        type: 'metasploit',
        bulletins: metasploit,
        family: 'exploit'
    },
    {
        type: 'mageia',
        bulletins: mageia,
        family: 'unix'
    },
    {
        type: 'wpvulndb',
        bulletins: wpvulndb,
        family: 'software'
    },
    {
        type: 'freebsd',
        bulletins: freebsd,
        family: 'unix'
    },
    {
        type: 'altlinux',
        bulletins: altlinux,
        family: 'unix'
    },
    {
        type: 'veeam',
        bulletins: veeam,
        family: 'software'
    },
    {
        type: 'nmap',
        bulletins: nmap,
        family: 'scanner'
    },
    {
        type: 'prion',
        bulletins: prion,
        family: 'NVD'
    },
    {
        type: 'cisco',
        bulletins: cisco,
        family: 'software'
    },
    {
        type: 'zdi',
        bulletins: zdi,
        family: 'info'
    },
    {
        type: 'rapid7blog',
        bulletins: rapid7blog,
        family: 'info'
    },
    {
        type: 'hivepro',
        bulletins: hivepro,
        family: 'info'
    },
    {
        type: 'redhatcve',
        bulletins: redhatcve,
        family: 'info'
    },
    {
        type: 'fireeye',
        bulletins: fireeye,
        family: 'info'
    },
    {
        type: 'malwarebytes',
        bulletins: malwarebytes,
        family: 'blog'
    },
    {
        type: 'huntr',
        bulletins: huntr,
        family: 'bugbounty'
    },
    {
        type: 'cloudlinux',
        bulletins: cloudlinux,
        family: 'unix'
    },
    {
        type: 'atlassian',
        bulletins: atlassian,
        family: 'software'
    },
    {
        type: 'amazon',
        bulletins: amazon,
        family: 'unix'
    },
    {
        type: 'ubuntucve',
        bulletins: ubuntucve,
        family: 'info'
    },
    {
        type: 'wordfence',
        bulletins: wordfence,
        family: 'info'
    },
    {
        type: 'patchstack',
        bulletins: patchstack,
        family: 'software'
    },
    {
        type: 'cnvd',
        bulletins: cnvd,
        family: 'cnvd'
    },
    {
        type: 'ciscothreats',
        bulletins: ciscothreats,
        family: 'info'
    },
    {
        type: 'openbugbounty',
        bulletins: openbugbounty,
        family: 'bugbounty'
    },
    {
        type: 'vulnerlab',
        bulletins: vulnerlab,
        family: 'exploit'
    },
    {
        type: 'pentestpartners',
        bulletins: pentestpartners,
        family: 'blog'
    },
    {
        type: 'vmware',
        bulletins: vmware,
        family: 'software'
    }
];

export { bulletins };
